webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = register;
/* harmony export (immutable) */ __webpack_exports__["i"] = login;
/* harmony export (immutable) */ __webpack_exports__["h"] = bmobLogout;
/* harmony export (immutable) */ __webpack_exports__["k"] = resetPwd;
/* harmony export (immutable) */ __webpack_exports__["a"] = currentUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = queryArticleList;
/* unused harmony export getUserArticleNumber */
/* harmony export (immutable) */ __webpack_exports__["e"] = getArticleTotalNumber;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTotalCategories;
/* harmony export (immutable) */ __webpack_exports__["q"] = queryOneArticle;
/* harmony export (immutable) */ __webpack_exports__["m"] = queryDrafteList;
/* unused harmony export getUserDrafteNumber */
/* harmony export (immutable) */ __webpack_exports__["p"] = queryOneDraft;
/* harmony export (immutable) */ __webpack_exports__["r"] = pushArticle;
/* harmony export (immutable) */ __webpack_exports__["t"] = addArticleView;
/* harmony export (immutable) */ __webpack_exports__["s"] = pushDraft;
/* harmony export (immutable) */ __webpack_exports__["o"] = deatroyArticle;
/* harmony export (immutable) */ __webpack_exports__["n"] = deatroyDraft;
/* harmony export (immutable) */ __webpack_exports__["b"] = queryOneUser;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateUserInfo;
/* harmony export (immutable) */ __webpack_exports__["x"] = saveCode;
/* harmony export (immutable) */ __webpack_exports__["v"] = queryCodeList;
/* unused harmony export getUserCodeNumber */
/* harmony export (immutable) */ __webpack_exports__["u"] = queryOneCode;
/* harmony export (immutable) */ __webpack_exports__["w"] = deatroyCode;
/* harmony export (immutable) */ __webpack_exports__["f"] = getIpNumber;
/* harmony export (immutable) */ __webpack_exports__["g"] = setIpInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);






Bmob.initialize("d99e8ce57ab6e528", "131412");
var defultUserId = "2ebc9ccf83";

function register() {
  var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var params = {
      username: userInfo.username,
      password: userInfo.password,
      email: userInfo.email
    };
    Bmob.User.register(params).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
}

function login() {
  var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Bmob.User.login(userInfo.username, userInfo.password).then(function (user) {
      if (!user.emailVerified) {
        resolve({
          code: "001",
          email: user.email
        });
        return;
      }
      resolve({
        code: "000",
        avatar: user.avatar,
        userId: user.objectId
      });
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
}

function bmobLogout() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    try {
      Bmob.User.logout();
      resolve({
        code: "000",
        message: "登出成功"
      });
    } catch (error) {
      reject({
        code: "001",
        message: "登出失败"
      });
    }
  });
}

function resetPwd(payload) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Bmob.requestPasswordReset(payload).then(function (res) {
      resolve({
        code: "000",
        message: "发送成功"
      });
    }).catch(function (err) {
      console.error(err);
      reject({
        code: "001",
        message: "重置错误"
      });
    });
  });
}

function currentUser() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var currentUser = Bmob.User.current();
    if (currentUser) {
      resolve(currentUser);
    } else {
      reject({
        code: "001",
        message: "未登录"
      });
    }
  });
}

function queryArticleList() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var pageData = config.pageData;
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var _this = this;

    var table = "article_list";

    var query = Bmob.Query(table);
    query.limit(pageData.pageNum);
    query.skip((pageData.currentPage - 1) * pageData.pageNum);

    query.order("-updatedAt");

    if (pageData.col) {
      query.equalTo("col", "==", pageData.col);
    }

    if (pageData.tags) {}

    if (pageData.objectIdAry) {
      query.containedIn("objectId", objectIdAry);
    }

    query.equalTo("userId", "==", config.userId || defultUserId);

    query.select("col", "createdAt", "intro", "mainTitle", "objectId", "original", "tags", "updatedAt", "userId");

    query.find().then(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(result) {
        var articleList, i, object, totalRes, newData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                articleList = [];

                for (i = 0; i < result.length; i++) {
                  object = result[i];

                  object.tags = object.tags.split("，");
                  object.ID = result[i].objectId;
                  object.date = result[i].createdAt;
                  object.updateDate = result[i].updatedAt;
                  articleList.push(object);
                }
                _context.next = 4;
                return getUserArticleNumber({ userId: config.userId });

              case 4:
                totalRes = _context.sent;
                newData = {
                  articleList: articleList,
                  count: totalRes[0] ? totalRes[0]._count : 0
                };

                resolve(newData);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x4) {
        return _ref.apply(this, arguments);
      };
    }()).catch(function (err) {
      console.error(err);
      console.log("err", err);
      reject("文章加载失败");
    });
  });
}

function getUserArticleNumber() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_list";
    var query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query.find().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject("统计所有文章数量获取失败");
    });
  });
}

function getArticleTotalNumber() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_list";
    var query = Bmob.Query(table);
    if (config.col) {
      query.equalTo("col", "==", config.col);
    }
    query.equalTo("userId", "==", config.userId || defultUserId);

    query.statTo("sum", "wordCount");
    query.find().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject("字数统计获取失败");
    });
  });
}

function getTotalCategories() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_list";
    var query = Bmob.Query(table);
    if (config.col) {
      query.equalTo("col", "==", config.col);
    }
    query.equalTo("userId", "==", config.userId || defultUserId);

    query.statTo("groupby", "col");
    query.statTo("groupcount", "col");
    query.find().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject("统计所有文章分类获取失败");
    });
  });
}

function queryOneArticle(articleId) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_list";
    var query = Bmob.Query(table);
    query.get(articleId).then(function (result) {
      var object = result;
      object.tags = object.tags.split("，");
      object.ID = result.objectId;
      object.date = result.updatedAt;
      resolve(object);
    }).catch(function (err) {
      console.error(err);
      reject("文章不存在或已删除！");
    });
  });
}

function queryDrafteList() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var pageData = config.pageData;
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var _this2 = this;

    var table = "article_draft";

    var query = Bmob.Query(table);
    query.limit(pageData.pageNum);
    query.skip((pageData.currentPage - 1) * pageData.pageNum);

    query.order("-updatedAt");

    query.equalTo("userId", "==", config.userId || defultUserId);

    query.select("col", "createdAt", "intro", "mainTitle", "objectId", "original", "tags", "updatedAt", "userId");

    query.find().then(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
        var articleList, i, object, totalRes, newData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                articleList = [];

                for (i = 0; i < result.length; i++) {
                  object = result[i];

                  object.tags = object.tags.split("，");
                  object.ID = result[i].objectId;
                  object.date = result[i].updatedAt;
                  articleList.push(object);
                }
                _context2.next = 4;
                return getUserDrafteNumber({ userId: config.userId });

              case 4:
                totalRes = _context2.sent;
                newData = {
                  articleList: articleList,
                  count: totalRes[0] ? totalRes[0]._count : 0
                };

                resolve(newData);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x9) {
        return _ref2.apply(this, arguments);
      };
    }()).catch(function (err) {
      console.error(err);
      reject("草稿箱加载失败");
    });
  });
}

function getUserDrafteNumber() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_draft";
    var query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query.find().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject("统计所有草稿文章数量获取失败");
    });
  });
}

function queryOneDraft(draftId) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_draft";
    var query = Bmob.Query(table);
    query.get(draftId).then(function (result) {
      var object = result;
      object.tags = object.tags.split("，");
      object.ID = result.objectId;
      object.date = result.updatedAt;
      resolve(object);
    }).catch(function (err) {
      console.error(err);
      reject("草稿加载失败");
    });
  });
}

function pushArticle(articleObj) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!articleObj.objectId) {
      var table = "article_list";
      var query = Bmob.Query(table);
      query.save(articleObj).then(function (result) {
        resolve(result);
      }).catch(function (err) {
        console.error(err);

        reject("添加文章失败");
      });
    } else {
      var _table = "article_list";
      var _query = Bmob.Query(_table);
      _query.set("id", articleObj.objectId);
      delete articleObj.objectId;
      _query.save(articleObj).then(function (result) {
        resolve("文章更新成功");
      }).catch(function (err) {
        console.error(err);
        reject("文章更新失败");
      });
    }
  });
}

function addArticleView(params) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_list";
    var query = Bmob.Query(table);
    query.set("id", params.objectId);
    query.set("view", params.view);
    query.save().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
}

function pushDraft(articleObj) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!articleObj.objectId) {
      var table = "article_draft";
      var query = Bmob.Query(table);
      query.save(articleObj).then(function (result) {
        resolve(result);
      }).catch(function (err) {
        console.error(err);
        reject("添加草稿箱失败");
      });
    } else {
      var _table2 = "article_draft";
      var _query2 = Bmob.Query(_table2);
      _query2.set("id", articleObj.objectId);
      delete articleObj.objectId;
      _query2.save(articleObj).then(function (res) {
        resolve("草稿更新成功");
      }).catch(function (err) {
        console.error(err);
        reject("草稿更新失败");
      });
    }
  });
}

function deatroyArticle(articleId) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_list";
    var query = Bmob.Query(table);
    query.get(articleId).then(function (result) {
      result.destroy().then(function (res) {
        resolve("删除文章成功");
      }).catch(function (err) {
        reject("删除文章失败");
      });
    }).catch(function (err) {
      console.error(err);
      reject("文章加载失败");
    });
  });
}

function deatroyDraft(draftId) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "article_draft";
    var query = Bmob.Query(table);
    query.get(draftId).then(function (result) {
      result.destroy().then(function (res) {
        resolve("删除草稿成功");
      }).catch(function (err) {
        reject("删除草稿失败");
      });
    }).catch(function (err) {
      console.error(err);
      reject("草稿加载失败");
    });
  });
}

function queryOneUser() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defultUserId;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "_User";

    var query = Bmob.Query(table);
    query.select("avatar", "showName", "singName");

    query.get(userId).then(function (result) {
      resolve(result);
    }).catch(function (err) {
      console.error(err);

      reject("用户查找失败");
    });
  });
}

function updateUserInfo(userId, info) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "_User";
    var query = Bmob.Query(table);
    query.set("id", userId);
    query.save(info).then(function (result) {
      resolve(result[0]);
    }).catch(function (err) {
      console.error(err);
      reject("用户信息修改失败");
    });
  });
}

function saveCode(codeObject) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!codeObject.objectId) {
      var table = "code_list";
      var query = Bmob.Query(table);
      query.save(codeObject).then(function (result) {
        resolve("code添加成功");
      }).catch(function (err) {
        console.error(err);

        reject("code添加失败");
      });
    } else {
      var _table3 = "code_list";
      var _query3 = Bmob.Query(_table3);
      _query3.set("id", codeObject.objectId);
      delete codeObject.objectId;
      _query3.save(codeObject).then(function (result) {
        resolve("code更新成功");
      }).catch(function (err) {
        console.error(err);
        reject("code更新失败");
      });
    }
  });
}

function queryCodeList() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var pageData = config.pageData;
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var _this3 = this;

    var table = "code_list";

    var query = Bmob.Query(table);
    query.limit(pageData.pageNum);
    query.skip((pageData.currentPage - 1) * pageData.pageNum);

    query.order("-updatedAt");

    query.equalTo("userId", "==", config.userId || defultUserId);

    query.select("avatar", "codeTitle", "createdAt", "intro", "label", "objectId", "updatedAt", "userId");

    query.find().then(function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
        var totalRes, newData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getUserCodeNumber({ userId: config.userId });

              case 2:
                totalRes = _context3.sent;
                newData = {
                  result: result,
                  count: totalRes[0] ? totalRes[0]._count : 0
                };

                resolve(newData);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }));

      return function (_x13) {
        return _ref3.apply(this, arguments);
      };
    }()).catch(function (err) {
      console.error(err);
      reject("code加载失败");
    });
  });
}

function getUserCodeNumber() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "code_list";
    var query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query.find().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject("统计所有代码片段数量获取失败");
    });
  });
}

function queryOneCode(codeId) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!codeId) {
      return;
    }
    var table = "code_list";
    var query = Bmob.Query(table);
    query.get(codeId).then(function (result) {
      result["codeURL"] = location.origin + location.pathname + "#/code?userId=" + result.userId + "&snippetId=" + result.objectId;
      resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, result, result.atrributes));
    }).catch(function (err) {
      console.error(err);
      reject("code加载失败");
    });
  });
}

function deatroyCode(codeId) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "code_list";
    var query = Bmob.Query(table);
    query.get(codeId).then(function (result) {
      result.destroy().then(function (res) {
        resolve("删除code成功");
      }).catch(function (err) {
        console.error(err);
        reject("删除code失败");
      });
    }).catch(function (err) {
      console.error(err);
      reject("code加载失败");
    });
  });
}

function getIpNumber() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "ip_info";
    var query = Bmob.Query(table);
    query.equalTo("userId", "==", config.userId || defultUserId);

    query.statTo("groupby", "userId");
    query.statTo("groupcount", "userId");
    query.find().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject("统计访客数获取失败");
    });
  });
}

function setIpInfo(params) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var table = "ip_info";
    var query = Bmob.Query(table);
    for (var key in params) {
      params[key] && query.set(key, params[key]);
    }
    query.save().then(function (res) {
      resolve(res);
    }).catch(function (err) {
      console.error(err);
      reject(err);
    });
  });
}

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-61b92624",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ripple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ListfadeOut; });

function ripple(rippleWrap, callback) {
  var rippleWrapEle = document.querySelector('#' + rippleWrap);
  var rippleDiv = rippleWrapEle.querySelectorAll('.rippleWrap');
  for (var i = 0; i < rippleDiv.length; i++) {
    rippleDiv[i].addEventListener('click', creatRipple);
  }

  function creatRipple(e, callback) {
    var offsetL = this.getBoundingClientRect().left;
    var offsetT = this.getBoundingClientRect().top;
    var x = e.clientX;
    var y = e.clientY;
    var ripple = document.createElement('span');
    ripple.className = 'rippleSpan';
    var rippleW = ripple.offsetWidth;
    var rippleH = ripple.offsetHeight;
    ripple.style.position = 'absolute';
    ripple.style.left = x - offsetL - rippleW / 2 + 'px';
    ripple.style.top = y - offsetT - rippleH / 2 + 'px';
    this.removeChild(this.childNodes[0]);
    this.appendChild(ripple);
    callback && callback();
  }
};

function ListfadeOut() {
  var Ul = document.querySelector('.fadeOutList');
  var aLi = Ul.querySelectorAll('li');
  for (var i = 0; i < aLi.length; i++) {
    var oP = aLi[i].querySelectorAll('p')[0];
    oP.iAlpha = 0;
    oP.time = null;
    aLi[i].onmouseover = function () {
      var oP = this.querySelectorAll('p')[0];
      oP.time ? clearInterval(oP.time) : "";
      oP.style.opacity = 1;
      oP.style.filter = "alpha(opacity=100)";
      oP.iAlpha = 100;
      oP.parentNode.style.color = '#fff';
    };
    aLi[i].onmouseout = function () {
      var oP = this.querySelectorAll('p')[0];
      starmove(oP);
      oP.parentNode.style.color = '#383838';
    };
  }

  function starmove(obj) {
    obj.time ? clearInterval(obj.time) : "";
    obj.time = setInterval(function () {
      domove(obj);
    }, 14);
  }

  function domove(obj) {
    var iSpeed = 3;
    if (obj.iAlpha <= iSpeed) {
      clearInterval(obj.time);
      obj.iAlpha = 0;
      obj.time = null;
    } else {
      obj.iAlpha -= iSpeed;
    }
    obj.style.opacity = obj.iAlpha / 100;
    obj.style.filter = "alpha(opacity=" + obj.iAlpha + ")";
  }
};



/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  "data-v-11c4b47a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(228)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-5f5c3d24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-5af19a7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(227)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  "data-v-7ede5164",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_blog_index__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_blog_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__view_blog_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_time_index__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_time_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__view_time_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_code_index__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_code_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__view_code_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_article_index__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_article_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__view_article_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_BAM_layout__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_BAM_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__view_BAM_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_BAM_view_allBlog__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_BAM_view_allBlog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__view_BAM_view_allBlog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_BAM_view_writeBlog_index__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_BAM_view_writeBlog_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__view_BAM_view_writeBlog_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_BAM_view_draft__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_BAM_view_draft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__view_BAM_view_draft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_BAM_view_self__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_BAM_view_self___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__view_BAM_view_self__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_login_index__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__view_login_index__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: "/", redirect: "/blog" }, { path: "/blog", name: "blog", component: __WEBPACK_IMPORTED_MODULE_2__view_blog_index___default.a, meta: { keepAlive: true } }, { path: "/time", name: "time", component: __WEBPACK_IMPORTED_MODULE_3__view_time_index___default.a, meta: { keepAlive: true } }, { path: "/code", name: "code", component: __WEBPACK_IMPORTED_MODULE_4__view_code_index___default.a, meta: { keepAlive: true } }, { path: "/article", name: "article", component: __WEBPACK_IMPORTED_MODULE_5__view_article_index___default.a }, {
    path: "/BAM",
    component: __WEBPACK_IMPORTED_MODULE_6__view_BAM_layout___default.a,
    redirect: "/BAM/BAllBlog",
    meta: { requireAuth: true },
    children: [{
      path: "BAllBlog",
      name: "BAllBlog",
      component: __WEBPACK_IMPORTED_MODULE_7__view_BAM_view_allBlog___default.a,
      meta: { requireAuth: true }
    }, {
      path: "BWriteBlog",
      name: "BWriteBlog",
      component: __WEBPACK_IMPORTED_MODULE_8__view_BAM_view_writeBlog_index___default.a,
      meta: { requireAuth: true, keepAlive: false }
    }, {
      path: "BDraft",
      name: "BDraft",
      component: __WEBPACK_IMPORTED_MODULE_9__view_BAM_view_draft___default.a,
      meta: { requireAuth: true }
    }, { path: "BSelf", component: __WEBPACK_IMPORTED_MODULE_10__view_BAM_view_self___default.a, meta: { requireAuth: true } }]
  }, { path: "/login", name: "login", component: __WEBPACK_IMPORTED_MODULE_11__view_login_index___default.a }]
}));

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  "data-v-427a9fc7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_header_header__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_header_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_header_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Message_Message__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Message_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_Message_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_cookie__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bmob__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      messageShow: false,
      sendMessage: "",
      articleList: [],
      articleListCopy: this.articleList,
      articleCount: 0,
      wordCount: 0,
      userIpCount: 0,
      currentPage: 1,
      pageNum: 20,
      categories: [],
      tags: [],
      nowCategorie: "",
      nowTagName: "",
      userInfo: {},
      isLoading: false,
      scrollEl: ""
    };
  },
  created: function created() {
    this.getUserInfo();

    this.getWordCount();

    this.geUserIpCount();

    this.getCategories();

    this.clearArticleList();

    this.getArticleList();

    this.setUserIpInfo();
  },

  watch: {
    $route: function $route(to, from) {
      var _this = this;

      if (from.path.indexOf("/BAM") > -1 && to.path.indexOf("/BAM") === -1) {
        this.getUserInfo(true);
      }

      if (to.path.indexOf("/blog") > -1) {
        this.$nextTick(function () {
          _this.clearArticleList();

          _this.getArticleList();
        });
      }
    },
    articleList: function articleList(newVal) {
      this.articleListCopy = this.articleList;
    }
  },
  methods: {
    searchInfo: function searchInfo(keyWord) {
      this.articleList = getSearchInfo(keyWord, this.articleList);
    },
    getSearchInfo: function getSearchInfo(keyWord, list) {
      var _this2 = this;

      if (keyWord) {
        var aboutTitle = this.searchAbout(list, "mainTitle", keyWord);

        var aboutIntro = this.searchAbout(list, "intro", keyWord);

        var newAry = this.uniqueFunc([].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(aboutTitle), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(aboutIntro)), "objectId");

        newAry.forEach(function (item, index) {
          item.mainTitle = _this2.markHightLight(item.mainTitle, keyWord);
          item.intro = _this2.markHightLight(item.intro, keyWord);
        });
        return newAry;
      } else {
        return list;
      }
    },
    getTagInfo: function getTagInfo(tagName, list) {
      if (tagName) {
        var aboutTagList = this.searchAbout(list, "tags", tagName);

        var newAry = this.uniqueFunc(aboutTagList, "objectId");
        return newAry;
      } else {
        return list;
      }
    },
    uniqueFunc: function uniqueFunc(arr, uniId) {
      var res = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();
      return arr.filter(function (item) {
        return !res.has(item[uniId]) && res.set(item[uniId], 1);
      });
    },
    markHightLight: function markHightLight(str, keyWord) {
      var replaceReg = new RegExp(keyWord, "i");
      var ary = str.match(replaceReg);
      if (ary) {
        ary.forEach(function (item, index) {
          var replaceString = "<span style=\"color:red\">" + item + "</span>";
          str = str.replace(replaceReg, replaceString);
        });
      }
      return str;
    },
    searchAbout: function searchAbout(list, colm, keyWord) {
      var mylist = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(list));

      var searchList = mylist.filter(function (item) {
        var reg = new RegExp(keyWord, "i");
        var str = item[colm];

        if (Array.isArray(item[colm])) {
          str = item[colm].join(",");
        }
        return str ? str.match(reg) : false;
      });
      return searchList;
    },
    getUserId: function getUserId() {
      return window.localStorage.getItem("userId") || this.$route.query.userId || undefined;
    },
    getUserInfo: function getUserInfo(needLogin) {
      var _this3 = this;

      var userId = this.getUserId();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__bmob__["b" /* queryOneUser */])(userId).then(function (result) {
        result.userId = result.id;
        _this3.userInfo = result;
      }).catch(function (err) {
        needLogin && _this3.$router.push({ path: "/login" });
      });
    },
    getArticleList: function getArticleList() {
      var _this4 = this;

      var pageData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { currentPage: 1, pageNum: 20 };

      var userId = this.getUserId();

      pageData.col = this.nowCategorie;

      pageData.tags = this.nowTagName;

      this.isLoading = true;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__bmob__["c" /* queryArticleList */])({ userId: userId, pageData: pageData }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var _newArticleList;

          var newArticleList;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  newArticleList = _this4.articleList;

                  (_newArticleList = newArticleList).push.apply(_newArticleList, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(result.articleList));
                  newArticleList = _this4.getSearchInfo(_this4.$route.query.keyWord, newArticleList);

                  newArticleList = _this4.getTagInfo(_this4.nowTagName, newArticleList);
                  _this4.articleList = newArticleList;
                  _this4.articleCount = result.count;
                  _this4.currentPage = pageData.currentPage;
                  _this4.pageNum = pageData.pageNum;

                  _this4.getBlogTags();
                  _this4.isLoading = false;

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        _this4.showMessage(err);
        _this4.isLoading = false;
        setTimeout(function () {
          _this4.messageShow = false;
        }, 1500);
      });
    },
    autoLoadArticle: function autoLoadArticle() {
      var allPageNum = Math.ceil(this.articleCount / this.pageNum);
      if (this.currentPage < allPageNum) {
        this.currentPage++;

        this.getArticleList({
          currentPage: this.currentPage,
          pageNum: this.pageNum
        });
      }
    },
    getColumnArticle: function getColumnArticle(col) {
      if (this.isLoading) {
        return;
      }
      this.nowCategorie = col;

      this.clearArticleList();

      this.getArticleList();

      this.setTop();
    },
    getTagArticle: function getTagArticle(tagName) {
      if (this.isLoading) {
        return;
      }
      this.nowTagName = tagName;

      !tagName && this.clearArticleList();

      this.getArticleList();

      this.setTop();
    },
    getCategories: function getCategories() {
      var _this5 = this;

      var userId = this.getUserId();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__bmob__["d" /* getTotalCategories */])({ userId: userId }).then(function (result) {
        _this5.categories = result;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getBlogTags: function getBlogTags() {
      var _this6 = this;

      var newList = [];
      var tagsList = [];
      this.articleList.forEach(function (item) {
        item.tags.forEach(function (element) {
          newList.push(element);
          newList = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(newList)));
        }, _this6);
      }, this);
      newList.forEach(function (item) {
        tagsList.push(item);
      });
      this.tags = tagsList;
    },
    getWordCount: function getWordCount() {
      var _this7 = this;

      var userId = this.getUserId();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__bmob__["e" /* getArticleTotalNumber */])({ userId: userId }).then(function (result) {
        _this7.wordCount = result[0] ? result[0]._sumWordCount : 0;
      }).catch(function (err) {
        console.log(err);
      });
    },
    geUserIpCount: function geUserIpCount() {
      var _this8 = this;

      var userId = this.getUserId();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__bmob__["f" /* getIpNumber */])({ userId: userId }).then(function (result) {
        _this8.userIpCount = result[0] ? result[0]._count : 0;
      }).catch(function (err) {
        console.log(err);
      });
    },
    clearArticleList: function clearArticleList() {
      this.articleList = [];
    },
    showMessage: function showMessage(msg) {
      var _this9 = this;

      if (!this.messageShow) {
        this.messageShow = true;
        this.sendMessage = msg;
        setTimeout(function () {
          _this9.messageShow = false;
        }, 1500);
      }
    },
    setUserIpInfo: function setUserIpInfo() {
      var ipInfo = __WEBPACK_IMPORTED_MODULE_9__utils_cookie__["a" /* default */].getCookie("ipInfo") || "";
      if (!ipInfo) {
        ipInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          ipv4: window.returnCitySN.cip,
          area: window.returnCitySN.cname,
          citycode: window.returnCitySN.cid,
          userId: this.getUserId()
        }, this.getMobSysInfo());

        __WEBPACK_IMPORTED_MODULE_9__utils_cookie__["a" /* default */].setCookie("ipInfo", ipInfo, 1);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__bmob__["g" /* setIpInfo */])(ipInfo);
      }
    },
    getMobSysInfo: function getMobSysInfo() {
      Array.prototype.contains = function (needle) {
        for (i in this) {
          if (this[i].indexOf(needle) > 0) return i;
        }
        return -1;
      };

      var device_type = navigator.userAgent;
      var md = new MobileDetect(device_type);
      var os = md.os();
      var model = "";
      if (os == "iOS") {
        os = md.os() + md.version("iPhone");
        model = md.mobile();
      } else if (os == "AndroidOS") {
        os = md.os() + md.version("Android");
        var sss = device_type.split(";");
        var i = sss.contains("Build/");
        if (i > -1) {
          model = sss[i].substring(0, sss[i].indexOf("Build/"));
        }
      }
      return {
        os: os,
        model: model
      };
    },
    setTop: function setTop() {
      this.$nextTick(function () {
        window.pageYOffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    },
    getScrollTop: function getScrollTop() {
      return this.scrollEl.scrollTop;
    },
    getClientHeight: function getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
      }
      return clientHeight;
    },
    getScrollHeight: function getScrollHeight() {
      return this.scrollEl.scrollHeight;
    },
    onScroll: function onScroll() {
      if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 10) {
        var allPageNum = Math.ceil(this.articleCount / this.pageNum);

        if (!this.isLoading && this.currentPage < allPageNum) {
          this.currentPage++;

          this.getArticleList({
            currentPage: this.currentPage,
            pageNum: this.pageNum
          });
        }
      }
    }
  },
  mounted: function mounted() {
    this.scrollEl = document.getElementById("main");

    this.scrollEl.addEventListener("scroll", this.onScroll);
  },
  destroyed: function destroyed() {
    this.scrollEl.removeEventListener("scroll", this.onScroll);
  },

  components: {
    "v-header": __WEBPACK_IMPORTED_MODULE_7__components_common_header_header___default.a,
    "v-Message": __WEBPACK_IMPORTED_MODULE_8__components_common_Message_Message___default.a
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activeItem: "Barticle",
      defaultAvatar: __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default.a
    };
  },

  props: {
    userInfo: {
      type: Object
    }
  },
  watch: {
    $route: function $route(to, from) {
      var index = to.path.indexOf("/BAM");
      this.activeItem = to.path.substring(index + 5);
    }
  },
  mounted: function mounted() {
    var index = this.$route.path.indexOf("/BAM");
    if (index > -1) {
      this.activeItem = this.$route.path.substring(index + 5);
    }
  },

  methods: {
    getUserId: function getUserId() {
      return window.localStorage.getItem("userId") || this.$route.query.userId || undefined;
    },
    changeItem: function changeItem(item) {
      this.activeItem = item;
      var pathName = "/BAM/" + item;
      this.$router.push({ path: pathName });
    },
    toSelfPage: function toSelfPage() {
      this.$router.push({
        path: "/blog",
        query: { userId: this.userInfo.userId || this.getUserId() }
      });
    },
    toSelfCodePage: function toSelfCodePage() {
      this.$router.push({
        path: "/code",
        query: { userId: this.userInfo.userId || this.getUserId() }
      });
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bmob__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_comment_comment__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_comment_comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_comment_comment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading__);










var HEADINGSELECTOR = "h1, h2, h3, h4";

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-Alert": __WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert___default.a,
    "v-Loading": __WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading___default.a,
    "v-comment": __WEBPACK_IMPORTED_MODULE_5__components_comment_comment___default.a
  },
  data: function data() {
    return {
      alertShow: false,
      editShow: false,
      alertInfo: {},
      articleContentCopy: this.articleContent
    };
  },

  props: {
    articleContent: {
      type: Object
    },
    tags: {
      type: Array
    },
    userInfo: {
      type: Object,
      default: {}
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    articleContent: function articleContent() {
      var key = this.$route.query.keyWord;
      var newArticleObj = this.articleContent;

      if (key) {
        newArticleObj = this.markInfo(key, this.articleContent);
      }

      newArticleObj = this.addImgView(newArticleObj);

      this.articleContentCopy = newArticleObj;

      this.$previewRefresh();
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      tocbot.init({
        tocSelector: "#toc",
        contentSelector: "#article",
        headingSelector: HEADINGSELECTOR
      });
    });

    if (this.$route.query.userId === localStorage.getItem("userId")) {
      this.editShow = true;
    } else {
      this.editShow = false;
    }
  },
  updated: function updated() {
    var article = document.querySelector("#article");
    HEADINGSELECTOR.split(",").forEach(function (item, index) {
      var elList = article.querySelectorAll(item);
      elList.forEach(function (item, i) {
        item.setAttribute("id", "h_" + index + "_" + i);
      });
    });
    this.$nextTick(function () {
      tocbot.refresh();

      var toc = document.querySelector("#toc");
      var aEle = toc.querySelectorAll("a");
      aEle.forEach(function (item) {
        item.addEventListener("click", function (e) {
          var event = e || window.event;
          event.stopPropagation();
          event.preventDefault();
        });
      });
    });
  },

  directives: {
    highlight: function highlight(el) {
      var blocks = el.querySelectorAll("pre code");
      blocks.forEach(function (block) {
        hljs.highlightBlock(block);
      });
    }
  },
  methods: {
    toEditArticle: function toEditArticle() {
      var id = this.$route.query.articleId;
      this.$router.push({
        name: "BWriteBlog",
        params: { id: id, type: "blog" }
      });
    },
    toDeleteArticle: function toDeleteArticle() {
      var id = this.$route.query.articleId;
      this.alertShow = true;
      this.alertInfo = { id: id };
    },
    markInfo: function markInfo(keyWord, articleObj) {
      var replaceReg = new RegExp(keyWord, "ig");
      var replaceString = "<span style=\"color:red\">" + keyWord + "</span>";
      articleObj.mainTitle = articleObj.mainTitle.replace(replaceReg, replaceString);
      articleObj.render = articleObj.render.replace(replaceReg, replaceString);
      return articleObj;
    },
    addImgView: function addImgView(articleObj) {
      var imgReg = new RegExp("(<img)(.*?)(/>)", "gi");

      var replaceString = "$1 $2 preview='0' $3";
      articleObj.render = articleObj.render.replace(imgReg, replaceString);
      return articleObj;
    },
    imgShow: function imgShow(name) {
      var gallery = new Viewer(document.getElementById(name), {});
      gallery.show();
    },
    confirm: function confirm(info) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = info.id;
                _context.next = 3;
                return _this.toDeleteFile(id);

              case 3:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bmob__["o" /* deatroyArticle */])(id).then(function (res) {
                  _this.$emit("showMessage", res);

                  _this.$router.push({ path: "/blog" });
                  window.location.reload();
                  _this.alertShow = false;
                }).catch(function (err) {
                  _this.$emit("showMessage", res);
                  _this.alertShow = false;
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      this.alertShow = false;
    },
    toDeleteFile: function toDeleteFile(id, type) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var delList = _this2.getBmobFileList(_this2.articleContentCopy.content);
        var del = Bmob.File();

        delList.length && del.destroy(delList);
        resolve();
      });
    },
    getBmobFileList: function getBmobFileList(content) {
      var pattern = /!\[(.*?)\]\((.*?)\)/gm;
      var result = [];
      var matcher = void 0;
      while ((matcher = pattern.exec(content)) !== null) {
        result.push(matcher[2]);
      }
      return result;
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_codemirror__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_alert_alert__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_alert_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_alert_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_codemirror_lib_codemirror_css__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_codemirror_lib_codemirror_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_codemirror_lib_codemirror_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codemirror_theme_paraiso_light_css__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codemirror_theme_paraiso_light_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_codemirror_theme_paraiso_light_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_codemirror_mode_vue_vue_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_codemirror_mode_vue_vue_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_codemirror_mode_vue_vue_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_mode_javascript_javascript_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_mode_javascript_javascript_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_codemirror_mode_javascript_javascript_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_mode_css_css_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_mode_css_css_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_codemirror_mode_css_css_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_mode_stylus_stylus_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_mode_stylus_stylus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_codemirror_mode_stylus_stylus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_mode_markdown_markdown_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_mode_markdown_markdown_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_codemirror_mode_markdown_markdown_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_mode_php_php_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_mode_php_php_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_codemirror_mode_php_php_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_codemirror_mode_python_python_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_codemirror_mode_python_python_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_codemirror_mode_python_python_js__);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-codemirror": __WEBPACK_IMPORTED_MODULE_0_vue_codemirror__["codemirror"],
    "v-Alert": __WEBPACK_IMPORTED_MODULE_1__components_common_alert_alert___default.a
  },
  data: function data() {
    return {
      title: this.fileName,
      code: this.getBmobCode,
      editing: false,
      editOrDone: "编辑",
      alertShow: false,
      cmOptions: {
        tabSize: 2,
        mode: "text/x-vue",
        theme: "paraiso-light",
        lineNumbers: true,
        line: true,
        lineWiseCopyCut: true,
        readOnly: true
      }
    };
  },

  props: {
    isSelfCodePage: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    resCode: {
      type: String,
      default: ""
    },
    getBmobCode: {
      type: String,
      default: ""
    },
    fileName: {
      type: String,
      default: ""
    },
    newFlag: {
      type: Boolean,
      default: false
    },
    add: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.add) {
      this.editing = true;
      this.editOrDone = this.editing ? "完成" : "编辑";
      this.cmOptions.readOnly = !this.editing;
    }
    this.changeHighlight(this.fileName);
  },

  watch: {
    resCode: function resCode(newVal) {
      this.code = newVal;
    },
    getBmobCode: function getBmobCode(newVal) {
      this.code = newVal;
    },
    fileName: function fileName(newVal) {
      this.title = newVal;
      this.editing = false;
      this.editOrDone = this.editing ? "完成" : "编辑";
      this.cmOptions.readOnly = !this.editing;
    },
    newFlag: function newFlag(newVal) {
      if (newVal) {
        this.editing = true;
        this.editOrDone = this.editing ? "完成" : "编辑";
        this.cmOptions.readOnly = !this.editing;
      }
    }
  },
  methods: {
    onCmCodeChange: function onCmCodeChange(newCode) {
      this.code = newCode;
      this.$emit("emitCode", this.code, this.index, this.title);
    },
    titleChange: function titleChange(e) {
      this.title = e.target.value;
      this.changeHighlight(this.title);
      this.$emit("emitCode", this.code, this.index, this.title);
    },
    edit: function edit() {
      if (this.editing) {
        this.$emit("hasEdit", true);
        this.$emit("emitCode", this.code, this.index, this.title);
      } else {
        this.$emit("hasEdit", false);
      }
      this.editing = !this.editing;
      this.cmOptions.readOnly = !this.editing;
      this.editOrDone = this.editing ? "完成" : "编辑";
    },
    confirm: function confirm() {
      this.alertShow = false;
      this.$emit("hasEdit", true);
      this.$emit("delFile", this.index);
    },
    changeHighlight: function changeHighlight(title) {
      var res = title.match(/.\w+$/) || [];
      switch (res[0]) {
        case ".js":
        case ".json":
        case ".jsx":
          this.cmOptions.mode = "text/javascript";
          break;
        case ".vue":
          this.cmOptions.mode = "text/x-vue";
          break;
        case ".html":
          this.cmOptions.mode = "text/html";
          break;
        case ".css":
        case ".scss":
        case ".less":
          this.cmOptions.mode = "text/css";
          break;
        case ".styl":
          this.cmOptions.mode = "text/x-styl";
          break;
        case ".md":
          this.cmOptions.mode = "text/x-markdown";
          break;
        case ".php":
          this.cmOptions.mode = "text/x-php";
          break;
        case ".py":
          this.cmOptions.mode = "text/x-python";
          break;

        default:
          this.cmOptions.mode = "text";
          break;
      }
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_alert_alert__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_alert_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_alert_alert__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-Alert": __WEBPACK_IMPORTED_MODULE_0__components_common_alert_alert___default.a
  },
  data: function data() {
    return {
      editing: false,
      snippetTitleCopy: "",
      editOrDone: "编辑",
      labelListCopy: [],
      chooseLabelIndex: "",
      chooseLabelItem: "",
      addLabelShow: false,
      addLabelInfo: "",
      alertShow: false
    };
  },

  props: {
    isSelfCodePage: {
      type: Boolean,
      default: false
    },
    snippetTitle: {
      type: String,
      default: ""
    },
    snippetLabel: {
      type: String,
      default: ""
    },
    codeUrl: {
      type: String,
      default: ""
    },
    labelList: {
      type: Array,
      default: []
    },
    newFlag: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    snippetTitle: function snippetTitle(newVal) {
      this.snippetTitleCopy = newVal;
      this.$emit("titleDone", {
        snippetTitle: this.snippetTitleCopy
      });
      this.editing = false;
      this.editOrDone = this.editing ? "完成" : "编辑";
    },
    snippetLabel: function snippetLabel(newVal) {
      this.chooseLabelItem = newVal;
      this.$emit("titleDone", {
        chooseLabelItem: this.chooseLabelItem
      });
    },
    labelList: function labelList(newVal) {
      this.labelListCopy = newVal;
    },
    newFlag: function newFlag(newVal) {
      if (newVal) {
        this.editing = newVal;
        this.editOrDone = this.editing ? "完成" : "编辑";
      }
    }
  },
  methods: {
    edit: function edit(flag) {
      if (this.editing) {
        if (!this.snippetTitleCopy) {
          this.$emit("showMessage", "请输入标题");
          return;
        }
        if (!this.chooseLabelItem) {
          this.$emit("showMessage", "请输入标签");
          return;
        }
        this.$emit("hasEdit", true);
        this.$emit("titleDone", {
          snippetTitle: this.snippetTitleCopy,
          chooseLabelItem: this.chooseLabelItem
        });
      } else {
        this.$emit("hasEdit", false);

        this.chooseLabelIndex = this.labelListCopy.indexOf(this.chooseLabelItem);
      }
      this.editing = !this.editing;
      this.editOrDone = this.editing ? "完成" : "编辑";
    },
    chooseLabel: function chooseLabel(index, item) {
      this.chooseLabelIndex = index;
      this.chooseLabelItem = item;
    },
    addLabel: function addLabel() {
      var _this = this;

      this.addLabelShow = true;
      this.$nextTick(function () {
        _this.$refs.addLabel.focus();
      });
    },
    addLabelSure: function addLabelSure() {
      var flag = false;
      this.addLabelInfo = this.addLabelInfo.trim();
      if (this.labelListCopy.length === 0) {
        flag = false;
      } else {
        for (var k in this.labelListCopy) {
          if (this.addLabelInfo === this.labelListCopy[k]) {
            flag = true;
            break;
          }
        }
      }

      if (!this.addLabelInfo) {
        this.$emit("showMessage", "内容不能为空");
        this.addLabelShow = false;
        return;
      }
      if (!this.checkString(this.addLabelInfo)) {
        this.$emit("showMessage", "不能包含特殊字符");
        return;
      }
      if (flag) {
        this.$emit("showMessage", "此分类已存在");
        return;
      }
      this.labelListCopy.push(this.addLabelInfo);
      this.chooseLabelIndex = this.labelListCopy.length - 1;
      this.chooseLabelItem = this.addLabelInfo;
      this.addLabelInfo = "";
      this.addLabelShow = false;
    },
    checkString: function checkString(string) {
      var rule = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
      return rule.test(string);
    },
    confirm: function confirm() {
      this.alertShow = false;
      this.$emit("delAllSnippet");
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gitalk__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gitalk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gitalk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gitalk_dist_gitalk_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gitalk_dist_gitalk_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gitalk_dist_gitalk_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "comment",
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var commentConfig = {
      clientID: "9401eecf2a6a217670d7",
      clientSecret: "e86fc9cf02aedcdf13735dd4f223e1cb823800db",
      repo: "myBlog",
      owner: "abu3389",

      admin: ["abu3389"],

      id: this.$route.query.articleId.substr(0, 50),
      distractionFreeMode: false,
      proxy: "https://gitalk-proxy.abu3389.workers.dev/?https://github.com/login/oauth/access_token"
    };
    var gitalk = new __WEBPACK_IMPORTED_MODULE_0_gitalk___default.a(commentConfig);
    gitalk.render("gitalk-container");
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		sendMessage: {
			type: String
		},
		messageShow: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {};
	}
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    info: {
      type: String,
      default: '确定删除此文章吗？'
    },
    alertInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    confirm: function confirm() {
      this.$emit('confirm', this.alertInfo);
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_script_common__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_error_error__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_error_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_error_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bmob__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      alertShow: false,
      alertInfo: {}
    };
  },

  props: {
    articleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 20
    },
    nowTagName: {
      type: String,
      default: ""
    },
    toEdit: {
      type: Boolean,
      default: false
    },
    isDraft: {
      type: Boolean,
      default: false
    },
    isArticle: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allPageNum: function allPageNum() {
      return Math.ceil(this.articleCount / this.pageNum);
    }
  },
  methods: {
    chooseTag: function chooseTag(itemTag) {
      this.$emit("toTag", itemTag ? itemTag == this.nowTagName ? "" : itemTag : "");
    },
    toArticlePage: function toArticlePage(articleId) {
      if (this.isDraft) {
        this.toEditDraft(articleId);
        return;
      }

      var userId = this.articleList[0].userId || "";

      var keyWord = this.$route.query.keyWord || "";
      var query = { articleId: articleId };
      if (userId) {
        query.userId = userId;
      }

      if (keyWord) {
        query.keyWord = keyWord;
      }
      this.$router.push({ path: "/article", query: query });
    },
    toEditDraft: function toEditDraft(id) {
      this.$router.push({
        name: "BWriteBlog",
        params: { id: id, type: "draft" }
      });
    },
    toEditArticle: function toEditArticle(id) {
      this.$router.push({
        name: "BWriteBlog",
        params: { id: id, type: "blog" }
      });
    },
    toDeleteArticle: function toDeleteArticle(id, index, type) {
      this.alertShow = true;
      this.alertInfo = { id: id, index: index, type: type };
    },
    confirm: function confirm(info) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id, index, type;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = info.id, index = info.index, type = info.type;
                _context.next = 3;
                return _this.toDeleteFile(id, type);

              case 3:
                if (type === "draft") {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__bmob__["n" /* deatroyDraft */])(id).then(function (res) {
                    _this.$emit("showMessage", res);
                    _this.articleList.splice(index, 1);
                    _this.alertShow = false;
                  }).catch(function (err) {
                    _this.$emit("showMessage", err);
                    _this.alertShow = false;
                  });
                } else {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__bmob__["o" /* deatroyArticle */])(id).then(function (res) {
                    _this.$emit("showMessage", res);
                    _this.articleList.splice(index, 1);

                    _this.$emit("getCategories");
                    _this.alertShow = false;
                  }).catch(function (err) {
                    _this.$emit("showMessage", err);
                    _this.alertShow = false;
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      this.alertShow = false;
    },
    toDeleteFile: function toDeleteFile(id, type) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var delList = [];
        var del = Bmob.File();
        if (type == "draft") {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__bmob__["p" /* queryOneDraft */])(id).then(function (res) {
            delList = _this2.getBmobFileList(res.content);

            delList.length && del.destroy(delList);
          });
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__bmob__["q" /* queryOneArticle */])(id).then(function (res) {
            delList = _this2.getBmobFileList(res.content);

            delList.length && del.destroy(delList);
          });
        }
        resolve();
      });
    },
    getBmobFileList: function getBmobFileList(content) {
      var pattern = /!\[(.*?)\]\((.*?)\)/gm;
      var result = [];
      var matcher = void 0;
      while ((matcher = pattern.exec(content)) !== null) {
        result.push(matcher[2]);
      }
      return result;
    }
  },
  components: {
    "v-Alert": __WEBPACK_IMPORTED_MODULE_4__components_common_alert_alert___default.a,
    "v-Loading": __WEBPACK_IMPORTED_MODULE_6__components_common_loading_loading___default.a,
    "v-ErrorCom": __WEBPACK_IMPORTED_MODULE_5__components_common_error_error___default.a
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isMore: false
    };
  },

  props: {
    tags: {
      type: Array
    },
    nowTagName: {
      type: String,
      default: ""
    }
  },
  methods: {
    chooseTag: function chooseTag(itemTag) {
      this.$emit("toTag", itemTag ? itemTag == this.nowTagName ? "" : itemTag : "");
    },
    getMore: function getMore() {
      this.isMore = true;
    }
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_script_common__ = __webpack_require__(38);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isMore: false
    };
  },

  props: {
    categories: {
      type: Array,
      default: []
    },
    nowCategorie: {
      type: String
    }
  },
  computed: {
    allLength: function allLength() {
      var totalNum = 0;
      this.categories.forEach(function (item) {
        totalNum += item._count;
      }, this);
      return totalNum;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_script_common__["b" /* ListfadeOut */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_script_common__["a" /* ripple */])("sideBarRippleWrap");
    });
  },

  watch: {
    categories: function categories() {
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_script_common__["b" /* ListfadeOut */])();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_script_common__["a" /* ripple */])("sideBarRippleWrap");
      });
    }
  },
  methods: {
    getArticle: function getArticle(col) {
      this.$emit("getColumnArticle", col ? col : "");
    },
    getMore: function getMore() {
      this.isMore = true;
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_script_common__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bmob__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activeRoute: "/blog",
      searchInfo: "",
      isBAM: false,
      navListIsShow: true,
      searchIsShow: true,
      messageShow: false,
      sendMessage: "",
      slideDown: false,
      avatar: __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default.a,
      userID: ""
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.getUserInfo();
      this.activeRoute = to.path;

      if (to.path.indexOf("/BAM") > -1) {
        this.isBAM = true;
        this.navListIsShow = true;
        this.searchIsShow = false;
      } else {
        this.isBAM = false;
        this.navListIsShow = true;
        this.searchIsShow = true;
      }

      if (to.path.indexOf("/login") !== -1) {
        this.activeRoute = "/BAM";
      }
    },

    "$route.query.keyWord": {
      immediate: true, handler: function handler(val) {
        this.searchInfo = val;

        this.slideDown = val ? true : false;
      }
    }
  },
  methods: {
    getUserInfo: function getUserInfo() {
      this.userID = window.localStorage.getItem("userId") || "";
      this.avatar = this.userID ? window.localStorage.getItem("avatar") : __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default.a;
    },
    logout: function logout() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bmob__["h" /* bmobLogout */])().then(function (result) {
        if (result.code === "000") {
          localStorage.clear();

          _this.getUserInfo();

          _this.$emit("getWordCount");
          var routeQuery = _this.$route.query;
          var routePath = _this.$route.path;
          if (routePath.indexOf("/BAM") > -1) {
            _this.$router.replace({ path: "/blog", query: routeQuery });
          } else {
            window.location.reload();
          }
          if (!_this.messageShow) {
            _this.messageShow = true;
            _this.sendMessage = result.message;
            setTimeout(function () {
              _this.messageShow = false;
            }, 1500);
          }
        }
      }).catch(function (err) {
        if (err.code === "001") {
          if (!_this.messageShow) {
            _this.messageShow = true;
            _this.sendMessage = err.message;
            setTimeout(function () {
              _this.messageShow = false;
            }, 1500);
          }
        }
      });
    },
    getUserId: function getUserId() {
      return window.localStorage.getItem("userId") || this.$route.query.userId || undefined;
    },
    changeHash: function changeHash(type) {
      var userId = this.getUserId();
      var keyWord = this.$route.query.keyWord || "";
      if (type === "BAM") {
        this.$router.push({ path: "/" + type });
        return;
      }
      var query = {};
      userId && (query.userId = userId);
      keyWord && (query.keyWord = keyWord);

      if (this.isBAM && type === "blog") {
        this.$router.push({ path: "/blog", query: query });
        return;
      }
      this.$router.push({ path: "/" + type, query: query });
    },
    showSearch: function showSearch(e) {
      e.target.nextElementSibling.focus();
      this.slideDown = this.slideDown ? false : true;
    },
    searchSubmit: function searchSubmit() {
      var userId = this.getUserId();

      this.searchInfo = this.searchInfo.trim();
      var query = {};

      if (userId) {
        query.userId = userId;
      }

      if (this.searchInfo) {
        query.keyWord = this.searchInfo;
      }
      this.$router.push({ path: "/blog", query: query });
    }
  },
  mounted: function mounted() {
    this.getUserInfo();

    if (this.$route.path.indexOf("/BAM") > -1) {
      this.activeRoute = this.$route.path;
      this.isBAM = true;

      this.searchIsShow = false;
    }

    if (this.$route.path.indexOf("/login") !== -1) {
      this.activeRoute = "/BAM";
    }

    if (this.$route.path.indexOf("/time") !== -1) {
      this.activeRoute = "/time";
    }

    if (this.$route.path.indexOf("/code") !== -1) {
      this.activeRoute = "/code";
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_script_common__["a" /* ripple */])("headerRippleWrap");
  },

  components: {
    "v-Message": __WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message___default.a
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_catalogue_catalogue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_catalogue_catalogue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_catalogue_catalogue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_blogTags_blogTags__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_blogTags_blogTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_blogTags_blogTags__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    categories: {
      type: Array
    },
    tags: {
      type: Array
    },
    nowCategorie: {
      type: String,
      default: ""
    },
    nowTagName: {
      type: String,
      default: ""
    }
  },
  components: {
    "v-catalogue": __WEBPACK_IMPORTED_MODULE_0__components_common_catalogue_catalogue___default.a,
    "v-blogTags": __WEBPACK_IMPORTED_MODULE_1__components_common_blogTags_blogTags___default.a
  },
  methods: {
    getColumnArticle: function getColumnArticle(col) {
      this.$emit("getColumnArticle", col);
    },
    toTag: function toTag(itemTag) {
      this.$emit("toTag", itemTag);
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_error_error__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_error_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_error_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_loading_loading__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_loading_loading__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-ErrorCom": __WEBPACK_IMPORTED_MODULE_0__components_common_error_error___default.a,
    "v-Loading": __WEBPACK_IMPORTED_MODULE_1__components_common_loading_loading___default.a
  },
  props: {
    yearList: {
      type: Object
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 10
    },
    isLoading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    allPageNum: function allPageNum() {
      return Math.ceil(this.articleCount / this.pageNum);
    }
  },
  methods: {
    toArticlePage: function toArticlePage(id) {
      var userId = this.$route.query.userId;
      if (userId === undefined) {
        this.$router.push({ path: "/article", query: { articleId: id } });
      } else {
        this.$router.push({
          path: "/article",
          query: { userId: userId, articleId: id }
        });
      }
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bmob__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BAM_side_side__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BAM_side_side___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_BAM_side_side__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_defaultIcon_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_defaultIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_defaultIcon_png__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-BAMSide": __WEBPACK_IMPORTED_MODULE_1__components_BAM_side_side___default.a,
    "v-Message": __WEBPACK_IMPORTED_MODULE_2__components_common_Message_Message___default.a
  },
  data: function data() {
    return {
      messageShow: false,
      sendMessage: "",
      userInfo: { avatar: __WEBPACK_IMPORTED_MODULE_3__assets_img_defaultIcon_png___default.a }
    };
  },

  props: {
    articleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 20
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.getUserInfo();
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bmob__["a" /* currentUser */])().then(function (result) {
        _this.userInfo = {
          avatar: result.avatar,
          showName: result.showName,
          singName: result.singName,
          userId: result.id
        };
      }).catch(function (err) {
        console.log("err", err);

        _this.$router.push({ path: "/login" });
      });
    },
    showMessage: function showMessage(msg) {
      this.$emit("showMessage", msg);
    },
    getCategories: function getCategories() {
      this.$emit("getCategories");
    },
    getWordCount: function getWordCount() {
      this.$emit("getWordCount");
    },
    getArticleList: function getArticleList(data) {
      this.$emit("getArticleList", data);
    },
    clearArticleList: function clearArticleList() {
      this.$emit("clearArticleList");
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_article_article__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_article_article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_article_article__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-article": __WEBPACK_IMPORTED_MODULE_0__components_common_article_article___default.a
  },
  data: function data() {
    return {
      currentPageCopy: this.currentPage,
      scrollEl: ""
    };
  },

  props: {
    articleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 20
    },
    userInfo: {
      type: Object,
      default: {}
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentPage: function currentPage(newVal) {
      this.currentPageCopy = newVal;
    }
  },
  mounted: function mounted() {
    this.scrollEl = document.getElementById("BAMCom");

    this.scrollEl.addEventListener("scroll", this.onScroll);
  },
  destroyed: function destroyed() {
    this.scrollEl.removeEventListener("scroll", this.onScroll);
  },

  methods: {
    getScrollTop: function getScrollTop() {
      return this.scrollEl.scrollTop;
    },
    getClientHeight: function getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
      }
      return clientHeight;
    },
    getScrollHeight: function getScrollHeight() {
      return this.scrollEl.scrollHeight;
    },
    onScroll: function onScroll() {
      if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 0) {
        var allPageNum = Math.ceil(this.articleCount / this.pageNum);

        if (!this.isLoading && this.currentPageCopy < allPageNum) {
          this.currentPageCopy++;

          this.getArticleList({
            currentPage: this.currentPageCopy,
            pageNum: this.pageNum
          });
        }
      }
    },
    getCategories: function getCategories() {
      this.$emit("getCategories");
    },
    clearArticleList: function clearArticleList() {
      this.$emit("clearArticleList");
    },
    getArticleList: function getArticleList(data) {
      this.$emit("getArticleList", data);
    },
    showMessage: function showMessage(msg) {
      this.$emit("showMessage", msg);
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_article_article__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_article_article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_article_article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bmob__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-article": __WEBPACK_IMPORTED_MODULE_1__components_common_article_article___default.a
  },
  data: function data() {
    return {
      articleList: [],
      articleCount: 0,
      currentPage: 1,
      pageNum: 20,
      isLoading: true,
      scrollEl: ""
    };
  },
  mounted: function mounted() {
    this.getDrafteList();
    this.scrollEl = document.getElementById("BAMCom");

    this.scrollEl.addEventListener("scroll", this.onScroll);
  },
  destroyed: function destroyed() {
    this.scrollEl.removeEventListener("scroll", this.onScroll);
  },

  methods: {
    getUserId: function getUserId() {
      return window.localStorage.getItem("userId") || this.$route.query.userId || undefined;
    },
    getDrafteList: function getDrafteList() {
      var _this = this;

      var pageData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { currentPage: 1, pageNum: 20 };

      var userId = this.getUserId();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["m" /* queryDrafteList */])({ userId: userId, pageData: pageData }).then(function (res) {
        var _articleList;

        (_articleList = _this.articleList).push.apply(_articleList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.articleList));
        _this.articleCount = res.count;
        _this.currentPage = pageData.currentPage;
        _this.pageNum = pageData.pageNum;
        _this.isLoading = false;
      }).catch(function (err) {
        _this.showMessage(err);
        _this.isLoading = false;
      });
    },
    autoLoadArticle: function autoLoadArticle() {
      var allPageNum = Math.ceil(this.articleCount / this.pageNum);
      if (this.currentPage < allPageNum) {
        this.currentPage++;

        this.getDrafteList({
          currentPage: this.currentPage,
          pageNum: this.pageNum
        });
      }
    },
    getScrollTop: function getScrollTop() {
      return this.scrollEl.scrollTop;
    },
    getClientHeight: function getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
      }
      return clientHeight;
    },
    getScrollHeight: function getScrollHeight() {
      return this.scrollEl.scrollHeight;
    },
    onScroll: function onScroll() {
      if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 0) {
        var allPageNum = Math.ceil(this.articleCount / this.pageNum);

        if (!this.isLoading && this.currentPage < allPageNum) {
          this.currentPage++;

          this.getDrafteList({
            currentPage: this.currentPage,
            pageNum: this.pageNum
          });
        }
      }
    },
    showMessage: function showMessage(msg) {
      this.$emit("showMessage", msg);
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bmob__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      avatar: __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default.a,
      showName: "",
      email: "",
      shortInt: "",
      imgListObj: {}
    };
  },

  computed: {
    surplus: function surplus() {
      if (!this.shortInt) {
        return;
      }
      if (500 - this.shortInt.length <= 0) {
        return 0;
      }
      return 500 - this.shortInt.length;
    }
  },
  mounted: function mounted() {
    this.initUserInfo();
  },

  methods: {
    initUserInfo: function initUserInfo() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bmob__["a" /* currentUser */])().then(function (result) {
        _this.userId = result.objectId;
        _this.avatar = result.avatar || __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default.a;
        _this.showName = result.showName;
        _this.email = result.email;
        _this.shortInt = result.singName;
      }).catch(function (err) {
        _this.$router.push({ path: "/login" });
      });
    },
    updateShortInt: function updateShortInt(event) {
      this.shortInt = event.target.value.substring(0, 500);
    },
    uploadAvatar: function uploadAvatar(e) {
      var _this2 = this;

      var imgfile = e.target.files[0];
      if (!imgfile) {
        return;
      }

      if (imgfile.size > 1 * 1000 * 1000) {
        this.$emit("showMessage", "上传文件大小不允许超过1M");
        return;
      }

      var lastModified = imgfile.lastModified.toString();
      var size = imgfile.size.toString();
      var tempName = lastModified + "-" + size;
      if (this.imgListObj[tempName]) {
        this.avatar = this.imgListObj[tempName];
        return;
      }

      var bmobFile = Bmob.File(imgfile["name"], imgfile);
      bmobFile.save().then(function (res) {
        console.log("res", res);

        var lastModified = imgfile.lastModified.toString();
        var size = imgfile.size.toString();
        var tempName = lastModified + "-" + size;
        _this2.imgListObj[tempName] = res[0].url;
        _this2.avatar = res[0].url;
      }).catch(function (err) {
        _this2.$emit("showMessage", "上传失败");
      });
    },
    updateSelfInfo: function updateSelfInfo() {
      var _this3 = this;

      var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!reg.test(this.email)) {
        this.$emit("showMessage", "请输入正确的email格式");
        return;
      }
      var data = {
        avatar: this.avatar || __WEBPACK_IMPORTED_MODULE_0__assets_img_defaultIcon_png___default.a,
        showName: this.showName || "fepawn_" + (Math.random() * 100000).toString().substring(0, 4),
        username: this.email,
        email: this.email,
        singName: this.shortInt
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bmob__["l" /* updateUserInfo */])(this.userId, data).then(function (res) {
        _this3.$emit("showMessage", "更新成功");
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bmob__["h" /* bmobLogout */])();
      }, function (err) {
        _this3.$emit("showMessage", err);
      }).then(function (result) {
        if (result.code === "000") {
          _this3.$router.push({ name: "login", params: { updateInfo: true } });
        }
      });
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bmob__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_alert_alert__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_alert_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_alert_alert__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userId: "",
      articleTitle: "",
      isOriginal: "原创",
      articleValue: "",
      articleHtml: "",
      col: {},
      chooseColumn: "",
      addColumnShow: false,
      addColumnInfo: "",
      tags: [],
      articlePushId: "",
      draftPushId: "",
      enterTagsInfo: "",
      placeholder: "请使用Markdown语法编辑...",
      saveRecord: "",
      lastTime: "",
      alertShow: false,
      alertInfo: "",
      subfield: true,
      allowPush: true,
      toolbarsFlag: true,
      codeStyle: "vs2015",
      ishljs: true,
      toolbars: {
        bold: true,
        italic: true,
        underline: true,
        strikethrough: true,
        mark: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        readmodel: true,
        help: true,
        undo: true,
        redo: true,
        trash: true,
        save: true,
        navigation: true,
        alignleft: true,
        aligncenter: true,
        alignright: true,
        subfield: true,
        preview: true },
      imgListObj: {},
      bmobFileList: [],
      loadingShow: false
    };
  },

  components: {
    "v-Alert": __WEBPACK_IMPORTED_MODULE_3__components_common_alert_alert___default.a
  },
  watch: {
    $route: function $route(to, from) {
      if (from.path.indexOf("/article") > -1) {
        this.initUserInfo();
      }
    },
    articleTitle: function articleTitle() {
      this.autoSave();
    },
    articleValue: function articleValue() {
      this.autoSave();
    },
    chooseColumn: function chooseColumn() {
      this.autoSave();
    },
    tags: function tags() {
      this.autoSave();
    }
  },
  created: function created() {
    this.initUserInfo();
    if (this.browserRedirect()) {
      this.toolbarsFlag = true;
      this.subfield = false;
      this.toolbars = {
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        readmodel: true,
        help: true,
        undo: true,
        redo: true,
        trash: true,
        save: true,
        alignleft: true,
        aligncenter: true,
        alignright: true };
    }
  },

  methods: {
    initPage: function initPage() {
      var _this = this;

      var articleId = this.$route.params.id;
      var type = this.$route.params.type;
      if (type === "draft") {
        this.getDraftInfo(articleId);
        this.getCategories();
      } else if (type === "blog") {
        this.getArticleInfo(articleId);
        this.getCategories();
      } else {
        var articleInfo = JSON.parse(window.localStorage.getItem("articleInfo"));
        this.saveRecord = articleInfo;

        if (articleInfo) {
          this.articleTitle = articleInfo.title;
          this.articleValue = articleInfo.content;
          var colAry = articleInfo.col;
          colAry.forEach(function (item, index) {
            _this.col[item] = index;
          });

          this.chooseColumn = articleInfo.chooseColumn;
          this.tags = articleInfo.tags;
          this.articlePushId = articleInfo.articlePushId;
        } else {
          this.getCategories();
        }
      }
    },
    getUserId: function getUserId() {
      return window.localStorage.getItem("userId") || this.$route.query.userId || undefined;
    },
    getCategories: function getCategories() {
      var _this2 = this;

      this.loadingShow = true;
      var userId = this.getUserId();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["d" /* getTotalCategories */])({ userId: userId }).then(function (result) {
        _this2.loadingShow = false;
        var colObj = {};
        result.forEach(function (item) {
          colObj[item.col] = item._count;
        });
        _this2.col = colObj;
      }).catch(function (err) {
        _this2.loadingShow = false;
        console.log(err);
      });
    },
    getDraftInfo: function getDraftInfo(draftId) {
      var _this3 = this;

      this.loadingShow = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["p" /* queryOneDraft */])(draftId).then(function (res) {
        _this3.loadingShow = false;
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.col).indexOf(res.col) > -1) {
          _this3.chooseColumn = res.col;
        } else {
          _this3.col[res.col] = null;
          _this3.chooseColumn = res.col;
        }
        _this3.draftPushId = res.ID;
        _this3.articleTitle = res.mainTitle;
        _this3.articleValue = res.content;
        _this3.getBmobFileList(res.content);
        _this3.tags = res.tags;
        _this3.isOriginal = res.original;
      }).catch(function (err) {
        _this3.loadingShow = false;
        _this3.$emit("showMessage", err);
      });
    },
    getArticleInfo: function getArticleInfo(articleId) {
      var _this4 = this;

      this.loadingShow = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["q" /* queryOneArticle */])(articleId).then(function (res) {
        _this4.loadingShow = false;
        _this4.articlePushId = res.ID;
        _this4.articleTitle = res.mainTitle;
        _this4.articleValue = res.content;
        _this4.getBmobFileList(res.content);
        _this4.chooseColumn = res.col;
        _this4.tags = res.tags;
        _this4.isOriginal = res.original;
      }).catch(function (err) {
        _this4.loadingShow = false;
        _this4.$emit("showMessage", err);
      });
    },
    getBmobFileList: function getBmobFileList(content) {
      var pattern = /!\[(.*?)\]\((.*?)\)/gm;
      var result = [];
      var matcher = void 0;
      while ((matcher = pattern.exec(content)) !== null) {
        result.push(matcher[2]);
      }
      this.bmobFileList = result;
    },
    autoSave: function autoSave() {
      this.save(this.articleValue, "", false);
    },
    save: function save(value, render) {
      var msgShow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var colAry = [];
      for (var key in this.col) {
        colAry.push(key);
      }
      var info = {
        content: value,
        title: this.articleTitle,
        col: colAry,
        chooseColumn: this.chooseColumn,
        tags: this.tags,
        articlePushId: this.articlePushId
      };
      this.saveRecord = info;

      window.localStorage.setItem("articleInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
      this.lastTime = this.getCurrentDate(2);
      console.log("暂存成功！");
      if (msgShow) {
        this.$emit("showMessage", "文章已经暂存本地");
      }
    },
    clearLocal: function clearLocal() {
      this.alertInfo = "确认是否清除暂存？清除后发布将作为新文章发布";
      this.alertShow = true;
    },
    confirm: function confirm() {
      window.localStorage.removeItem("articleInfo");

      location.reload();
    },
    cancel: function cancel() {
      this.alertShow = false;
    },
    change: function change(value, render) {
      this.articleHtml = render;
    },
    imgDel: function imgDel(pos) {
      delete this.imgListObj[pos];
    },
    imgAdd: function imgAdd(filename, imgfile) {
      var _this5 = this;

      var lastModified = imgfile.lastModified.toString();

      var size = imgfile.size.toString();

      var tempName = lastModified + "-" + size;

      if (imgfile.size > 5 * 1000 * 1000) {
        this.$emit("showMessage", "上传文件大小不允许超过5M");
        return;
      }

      if (this.imgListObj[tempName]) {
        this.$refs.mavon.$img2Url(filename, this.imgListObj[tempName]);
        return;
      }

      var bmobFile = new Bmob.File(imgfile["name"], imgfile);
      this.allowPush = false;
      bmobFile.save().then(function (res) {
        _this5.bmobFileList.push(res[0].url);

        _this5.imgListObj[tempName] = res[0].url;

        _this5.$refs.mavon.$img2Url(filename, res[0].url);
        _this5.$emit("showMessage", imgfile["name"] + "上传成功");
        _this5.allowPush = true;
      }).catch(function (err) {
        _this5.$emit("showMessage", imgfile["name"] + "上传失败");
        _this5.allowPush = true;
      });
    },
    addColumn: function addColumn() {
      var _this6 = this;

      this.addColumnShow = true;
      this.$nextTick(function () {
        _this6.$refs.addColumn.focus();
      });
    },
    addColumnSure: function addColumnSure() {
      var flag = false;
      this.addColumnInfo = this.addColumnInfo.trim();

      if (this.col.length === 0) {
        flag = false;
      } else {
        for (var k in this.col) {
          if (this.addColumnInfo === this.col[k]) {
            flag = true;
            break;
          }
        }
      }

      if (!this.addColumnInfo) {
        this.$emit("showMessage", "内容不能为空");
        this.addColumnShow = false;
        return;
      }
      if (!this.checkString(this.addColumnInfo)) {
        this.$emit("showMessage", "不能包含特殊字符");
        return;
      }
      if (flag) {
        this.$emit("showMessage", "此分类已存在");
        return;
      }
      this.addColumnShow = false;

      this.col[this.addColumnInfo] = 0;
      this.chooseColumn = this.addColumnInfo;
      this.addColumnInfo = "";
    },
    chooseCol: function chooseCol(col) {
      this.chooseColumn = col;
    },
    addTagsSure: function addTagsSure() {
      var _this7 = this;

      var index = void 0;
      this.enterTagsInfo = this.enterTagsInfo.trim();
      if (this.tags.length === 0) {
        index = -1;
      } else {
        index = this.tags.findIndex(function (value, index, arr) {
          return value === _this7.enterTagsInfo;
        });
      }

      if (!this.enterTagsInfo) {
        this.$emit("showMessage", "内容不能为空");
        return;
      }
      if (this.enterTagsInfo.length > 20) {
        this.$emit("showMessage", "标签不能超过20个字符");
        return;
      }
      if (!this.checkString(this.enterTagsInfo)) {
        this.$emit("showMessage", "不能包含特殊字符");
        return;
      }
      if (index > -1) {
        this.$emit("showMessage", "此标签已存在");
        return;
      }
      if (this.tags.length >= 5) {
        this.$emit("showMessage", "标签不能超过5个");
        this.enterTagsInfo = "";
        return;
      }
      this.tags.push(this.enterTagsInfo);
      this.enterTagsInfo = "";
    },
    deleteTag: function deleteTag(e) {
      var index = e.target.getAttribute("index");
      this.tags.splice(index, 1);
    },
    checkString: function checkString(string) {
      var rule = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
      return rule.test(string);
    },
    addArticle: function addArticle(type) {
      var _this8 = this;

      var result = this.checkAll();
      if (!result) {
        return;
      }
      var data = {
        userId: this.getUserId(),
        mainTitle: this.articleTitle,
        tags: this.tags.join("，"),
        intro: this.articleHtml.replace(/\"/g, "'").substring(0, 120),
        col: this.chooseColumn,
        content: this.articleValue.replace(/\"/g, "'"),
        render: this.articleHtml.replace(/\"/g, "'"),
        original: this.isOriginal
      };
      data["wordCount"] = data.content.length;
      if (type) {
        if (this.articlePushId) {
          data["objectId"] = this.articlePushId;
        }

        this.loadingShow = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["r" /* pushArticle */])(data).then(function (res) {
          _this8.loadingShow = false;
          _this8.articlePushId ? _this8.$emit("showMessage", "更新文章成功！") : _this8.$emit("showMessage", "发布文章成功！");

          _this8.$router.push({ name: "BAllBlog" });

          _this8.reLoadList();

          if (_this8.draftPushId) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["n" /* deatroyDraft */])(_this8.draftPushId);
          }

          window.localStorage.removeItem("articleInfo");

          _this8.delBmobFile(_this8.bmobFileList, data.content);
        }, function (err) {
          _this8.loadingShow = false;
          _this8.$emit("showMessage", err);
        });
      } else {
        if (this.draftPushId) {
          data["objectId"] = this.draftPushId;
        }

        this.loadingShow = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["s" /* pushDraft */])(data).then(function (res) {
          _this8.loadingShow = false;
          _this8.draftPushId ? _this8.$emit("showMessage", "更新草稿成功！") : _this8.$emit("showMessage", "保存草稿成功！");

          if (_this8.articlePushId) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["o" /* deatroyArticle */])(_this8.articlePushId).then(function (res) {
              _this8.reLoadList();

              _this8.$router.push({ name: "BDraft" });
            });
          } else {
            _this8.loadingShow = false;
            _this8.$router.push({ name: "BDraft" });
          }

          window.localStorage.removeItem("articleInfo");

          _this8.delBmobFile(_this8.bmobFileList, data.content);
        }, function (err) {
          _this8.loadingShow = false;
          _this8.$emit("showMessage", err);
        });
      }
    },
    delBmobFile: function delBmobFile(files, markDownContent) {
      var delList = [];
      var del = Bmob.File();
      files.forEach(function (item) {
        if (markDownContent.indexOf(item) === -1) {
          delList.push(item);
        }
      });

      delList.length && del.destroy(delList);
    },
    reLoadList: function reLoadList() {
      this.$emit("clearArticleList");

      this.$emit("getArticleList");

      this.$emit("getCategories");

      this.$emit("getWordCount");
    },
    initUserInfo: function initUserInfo() {
      var _this9 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bmob__["a" /* currentUser */])().then(function (result) {
        _this9.userId = result.objectId;
        _this9.initPage();
      }).catch(function (err) {
        _this9.$router.push({ path: "/login" });
      });
    },
    checkAll: function checkAll() {
      if (this.articleTitle === "") {
        this.$emit("showMessage", "请填写博客标题");
        return false;
      }
      if (this.chooseColumn === "") {
        this.$emit("showMessage", "请填写分类");
        return false;
      }
      if (this.tags.length <= 0) {
        this.$emit("showMessage", "请填写标签");
        return false;
      }
      if (this.articleValue === "") {
        this.$emit("showMessage", "博客内容不能为空");
        return false;
      }
      return true;
    },
    browserRedirect: function browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentDate: function getCurrentDate(format) {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth();
      var date = now.getDate();
      var day = now.getDay();
      var hour = now.getHours();
      var minu = now.getMinutes();
      var sec = now.getSeconds();
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";

      if (format == 1) {
        time = year + "-" + month + "-" + date;
      } else if (format == 2) {
          time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
        }
      return time;
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_article_content_content__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_article_content_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_article_content_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bmob_js__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-content": __WEBPACK_IMPORTED_MODULE_0__components_article_content_content___default.a
  },
  data: function data() {
    return {
      articleContent: {},
      tags: [],
      articleId: 0,
      isLoading: false
    };
  },

  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  watch: {
    $route: function $route(to, from) {
      var _this = this;

      if (to.path.indexOf("/article") > -1) {
        this.$nextTick(function () {
          _this.articleId = to.query.articleId;
          _this.getArticle();
        });
      }
    }
  },
  created: function created() {
    this.articleId = this.$route.query.articleId;
    this.getArticle();
  },

  methods: {
    getArticle: function getArticle() {
      var _this2 = this;

      this.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bmob_js__["q" /* queryOneArticle */])(this.articleId).then(function (result) {
        _this2.isLoading = false;

        result.view = !result.view ? 1 : result.view + 1;
        _this2.articleContent = result;
        _this2.tags = _this2.articleContent.tags;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bmob_js__["t" /* addArticleView */])({ objectId: result.objectId, view: result.view });
      }).catch(function (err) {
        _this2.isLoading = false;
        _this2.$emit("showMessage", err);
        setTimeout(function () {
          _this2.$router.push({ path: "/blog" });
        }, 1500);
      });
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_article_article__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_article_article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_article_article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-article": __WEBPACK_IMPORTED_MODULE_0__components_common_article_article___default.a,
    "v-sidebar": __WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar___default.a
  },
  data: function data() {
    return {};
  },

  props: {
    articleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    articleCount: {
      type: Number,
      default: 0
    },
    wordCount: {
      type: Number,
      default: 0
    },
    userIpCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 10
    },
    userInfo: {
      type: Object,
      default: {}
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    nowCategorie: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    nowTagName: {
      type: String,
      default: ""
    }
  },
  methods: {
    getColumnArticle: function getColumnArticle(col) {
      this.$emit("getColumnArticle", col);
    },
    toTag: function toTag(itemTag) {
      this.$emit("getTagArticle", itemTag);
    },
    getArticleList: function getArticleList(data) {
      this.$emit("getArticleList", data);
    },
    showMessage: function showMessage(msg) {
      this.$emit("showMessage", msg);
    }
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_code_codeMirror_codeMirror_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_code_codeMirror_codeMirror_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_code_codeMirror_codeMirror_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_code_codeTitle_codeTitle_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_code_codeTitle_codeTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_code_codeTitle_codeTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bmob_js__ = __webpack_require__(6);








var nS = "newSnippet";

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "v-codemirror": __WEBPACK_IMPORTED_MODULE_3__components_code_codeMirror_codeMirror_vue___default.a,
    "v-codeTitle": __WEBPACK_IMPORTED_MODULE_4__components_code_codeTitle_codeTitle_vue___default.a
  },
  data: function data() {
    return {
      isSelfCodePage: false,
      userInfo: "",
      avatar: "",
      snippetTitle: "",
      snippetLabel: "",
      snippetTitleListAll: [],
      snippetTitleList: [],
      chooseItemIndex: 0,
      showCancel: false,
      labelListAll: [],
      labelList: [],
      chooseLabelIndex: "all",
      newFlag: false,
      codeUrl: "",
      titleInfo: {},
      getBmobCodeList: [{ code: "", title: "" }],
      codeHasEdit: false,
      newDisabled: false,
      loadingShow: false,
      articleCount: 0,
      currentPage: 1,
      pageNum: 20,
      mark: true
    };
  },
  created: function created() {
    this.init();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.setOption(to, from, next);
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.setOption(to, from, next);
  },

  watch: {
    $route: function $route(to, from) {
      if (from.path.indexOf("/BAM") > -1) {
        if (this.mark) {
          this.reload();
          this.mark = false;
        }
      }
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      this.clearCodeList();
      this.getCodeList(this.getUserId());
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__bmob_js__["a" /* currentUser */])().then(function (res) {
        _this.avatar = res.avatar;
        _this.userInfo = res.objectId;
        _this.isSelfCodePage = true;
      }).catch(function (err) {
        console.log(err);
        _this.isSelfCodePage = false;
      });
    },
    getUserId: function getUserId() {
      return window.localStorage.getItem("userId") || this.$route.query.userId || undefined;
    },
    setOption: function setOption(to, from, next) {
      var _this2 = this;

      var codeId = to.query.snippetId;

      if (codeId) {
        this.loadingShow = true;

        if (codeId === nS) {
          this.snippetTitle = "";
          this.snippetLabel = "";
          this.getBmobCodeList = [{ code: "", title: "" }];
          this.codeHasEdit = false;
          this.showCancel = true;
          this.chooseItemIndex = undefined;
          this.newFlag = true;
          this.codeUrl = "待生成...";
          this.loadingShow = false;
          next();
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__bmob_js__["u" /* queryOneCode */])(codeId).then(function (res) {
            _this2.snippetTitle = res.codeTitle;
            _this2.snippetLabel = res.label;
            _this2.codeUrl = res.codeURL;
            _this2.getBmobCodeList = res.snippetList;
            _this2.loadingShow = false;
            next();
          }, function (err) {
            _this2.loadingShow = false;
            next();
            console.log(err);
          });
        }
      }
    },
    reload: function reload() {
      this.$route.query.snippetId = "";
      this.init();
    },
    newSnippet: function newSnippet() {
      this.newFlag = true;
      this.chooseItemIndex = undefined;
      var query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { snippetId: nS });
      this.$router.push({ path: this.$route.path, query: query });
    },
    getLabelList: function getLabelList() {
      var labelList = [];
      var labelListAll = {};
      this.snippetTitleListAll.forEach(function (item) {
        var label = item && item && item.label;
        if (label) {
          labelList.push(label);
          if (labelListAll[label]) {
            labelListAll[label]++;
          } else {
            labelListAll[label] = 1;
          }
        }
      });
      this.labelListAll = labelListAll;
      this.labelList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(labelList)));
    },
    getCodeList: function getCodeList(userId) {
      var _this3 = this;

      var pageData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { currentPage: 1, pageNum: 20 };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__bmob_js__["v" /* queryCodeList */])({ userId: userId, pageData: pageData }).then(function (res) {
        var _snippetTitleList, _snippetTitleListAll;

        (_snippetTitleList = _this3.snippetTitleList).push.apply(_snippetTitleList, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.result));
        (_snippetTitleListAll = _this3.snippetTitleListAll).push.apply(_snippetTitleListAll, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.result));
        _this3.articleCount = res.count;
        _this3.autoLoadCodeList(pageData);
      }).catch(function (err) {
        console.log(err);
      });
    },
    clearCodeList: function clearCodeList() {
      this.snippetTitleList = [];
      this.snippetTitleListAll = [];
      this.pageNum = "";
      this.currentPage = "";
      this.articleCount = "";
    },
    chooseIt: function chooseIt() {
      if (this.$route.query && this.$route.query.snippetId && this.$route.query.snippetId != nS) {
        for (var i = 0; i < this.snippetTitleListAll.length; i++) {
          var item = this.snippetTitleListAll[i];
          if (this.$route.query.snippetId === item.objectId) {
            this.chooseItemIndex = i;
            break;
          }
        }
      } else {
        this.chooseItem(0);
      }

      this.getLabelList();
    },
    autoLoadCodeList: function autoLoadCodeList(pageData) {
      this.pageNum = pageData.pageNum;
      this.currentPage = pageData.currentPage;
      var allPageNum = Math.ceil(this.articleCount / this.pageNum);
      if (this.currentPage < allPageNum) {
        this.currentPage++;

        this.getCodeList(this.getUserId(), {
          currentPage: this.currentPage,
          pageNum: this.pageNum
        });
      } else {
        this.chooseIt();
      }
    },
    chooseItem: function chooseItem(index) {
      this.chooseItemIndex = index;
      var snippetId = this.snippetTitleList[index] && this.snippetTitleList[index].objectId;
      if (!snippetId) {
        this.loadingShow = false;
        return;
      }
      var query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.$route.query, {
        snippetId: snippetId
      });
      this.$router.push({ path: this.$route.path, query: query });
    },
    chooseLabel: function chooseLabel(key) {
      if (key === "all") {
        this.chooseLabelIndex = key;
        this.snippetTitleList = this.snippetTitleListAll;
        this.chooseItem(0);
        return;
      }
      this.chooseLabelIndex = key;
      var tempList = [];
      this.snippetTitleListAll.forEach(function (item, index) {
        if (item && item.label === key) {
          tempList.push(item);
        }
      });
      this.snippetTitleList = tempList;
      this.chooseItem(0);
    },
    titleDone: function titleDone(obj) {
      this.titleInfo = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.titleInfo, obj);
    },
    getEmitCode: function getEmitCode(code, index, title) {
      this.getBmobCodeList[index] = { code: code, title: title };
    },
    addSnippet: function addSnippet() {
      this.getBmobCodeList.push({ code: "", title: "", add: true });
    },
    delFile: function delFile(index) {
      this.getBmobCodeList.splice(index, 1);
    },
    delAllSnippet: function delAllSnippet() {
      var _this4 = this;

      var codeId = this.$route.query.snippetId;
      if (codeId === nS) {
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__bmob_js__["w" /* deatroyCode */])(codeId).then(function (res) {
        _this4.showMessage("删除代码片段成功");

        _this4.reload();
      }).catch(function (err) {
        _this4.showMessage("删除代码片段失败");
      });
    },
    hasEdit: function hasEdit(flag) {
      this.codeHasEdit = flag;
    },
    cancel: function cancel() {
      var snippetId = this.$route.query.snippetId;
      if (snippetId && snippetId === nS) {
        this.chooseItem(0);
      }
      this.codeHasEdit = false;
      this.showCancel = false;
    },
    submitCode: function submitCode() {
      var _this5 = this;

      if (!this.checkoutAll()) {
        return;
      }
      this.getBmobCodeList.forEach(function (item, index) {
        if (item.add) {
          _this5.getBmobCodeList.splice(index, 1);
        }
      });
      var userId = this.getUserId();
      var snippetId = this.$route.query.snippetId;
      if (userId === this.userInfo) {
        var params = {
          userId: this.userInfo,
          snippetList: this.getBmobCodeList,
          avatar: this.avatar,
          label: this.titleInfo.chooseLabelItem,
          intro: this.getBmobCodeList[0] && this.getBmobCodeList[0].code.slice(0, 20),
          codeTitle: this.titleInfo.snippetTitle
        };

        if (snippetId && snippetId !== nS) {
          params.objectId = snippetId;
        }

        this.codeHasEdit = false;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__bmob_js__["x" /* saveCode */])(params).then(function (res) {
          _this5.newDisabled = false;
          _this5.showMessage(res);
          _this5.init();
        }, function (err) {
          _this5.codeHasEdit = false;
          console.log(err);
        });
      } else {
        this.showMessage("请登录或至个人代码段页面");
      }
    },
    showMessage: function showMessage(msg) {
      this.$emit("showMessage", msg);
    },
    checkoutAll: function checkoutAll() {
      if (!this.titleInfo.snippetTitle) {
        this.showMessage("请输入标题");
        return false;
      }
      if (!this.titleInfo.chooseLabelItem) {
        this.showMessage("请输入标签");
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bmob__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userName: "",
      userPwd: "",
      userPwdAngin: "",
      restPwdEmail: "",
      avatar: "",
      tabFlag: "login",
      loginStatu: "登录"
    };
  },
  mounted: function mounted() {
    this.avatar = window.localStorage.getItem("avatar") || "";
    if (this.$route.params && this.$route.params.updateInfo) {
      this.showMessage("更新信息后需要重新登录！");
    }
  },

  methods: {
    loginSubmit: function loginSubmit() {
      var _this2 = this;

      var data = {};
      if (this.tabFlag === "login") {
        if (!this.verificate(data)) {
          this.showMessage("用户名或密码不能为空！");
          return;
        }
        var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        if (!reg.test(this.userName)) {
          this.showMessage("\u8BF7\u8F93\u5165\u6B63\u786E\u7684email\u683C\u5F0F");
          return;
        }
        this.loginStatu = "登录中...";

        data = { username: this.userName, password: this.userPwd };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bmob__["i" /* login */])(data).then(function (result) {
          _this2.loginStatu = "登录";
          if (result.code === "001") {
            var emailFormat = "**" + result.email.substring(2);
            _this2.showMessage("\u8BF7\u5148\u9A8C\u8BC1" + emailFormat + "\u90AE\u7BB1\uFF01");
            return;
          } else if (result.code === "000") {
            _this2.showMessage("\u767B\u5F55\u6210\u529F!");
            window.localStorage.setItem("avatar", result.avatar);
            window.localStorage.setItem("userId", result.userId);

            _this2.$emit("clearArticleList");

            _this2.$emit("getArticleList");

            _this2.$emit("getCategories");

            _this2.$emit("getWordCount");

            _this2.$emit("geUserIpCount");

            _this2.$router.push({
              path: "BAM",
              query: { userId: result.userId }
            });
          }
        }, function (error) {
          _this2.loginStatu = "登录";
          if (error.code === 101) {
            _this2.showMessage("\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF\uFF01");
          }
        });
      } else if (this.tabFlag === "register") {
        var _this = this;
        if (!this.verificate(data)) {
          this.showMessage("\u7528\u6237\u540D\u6216\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF01");
          return;
        }
        var _reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        if (!_reg.test(this.userName)) {
          this.showMessage("\u8BF7\u8F93\u5165\u6B63\u786E\u7684email\u683C\u5F0F");
          return;
        }
        if (this.userPwd.trim() !== this.userPwdAngin.trim()) {
          this.showMessage("\u4E24\u6B21\u8F93\u5165\u7684\u5BC6\u7801\u4E0D\u4E00\u81F4");
          return;
        }

        data = {
          username: this.userName,
          password: this.userPwd,
          email: this.userName
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bmob__["j" /* register */])(data).then(function (result) {
          _this2.showMessage("\u606D\u559C\u4F60\uFF0C\u6CE8\u518C\u6210\u529F\uFF01\u6FC0\u6D3B\u90AE\u7BB1\u5373\u53EF\u767B\u5F55\uFF01\u6FC0\u6D3B\u90AE\u4EF6\u53EF\u80FD\u4F1A\u67093-5\u5206\u949F\u5EF6\u8FDF,\u8BF7\u7B49\u5F85");
        }, function (res) {
          if (res.code === 202) {
            _this2.showMessage("\u7528\u6237\u540D\u5DF2\u7ECF\u5B58\u5728");
          } else if (res.code === 203) {
            _this2.showMessage("\u90AE\u7BB1\u5DF2\u7ECF\u5B58\u5728");
          } else {
            _this2.showMessage("" + res.message);
          }
        });
      }
    },
    resetPassword: function resetPassword() {
      var _this3 = this;

      var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!reg.test(this.restPwdEmail)) {
        this.showMessage("\u8BF7\u8F93\u5165\u6B63\u786E\u7684email\u683C\u5F0F");
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bmob__["k" /* resetPwd */])({ email: this.restPwdEmail }).then(function (res) {
        _this3.tabFlag = "login";
        _this3.restPwdEmail = "";
        _this3.showMessage("请去您的邮箱重置密码！");
      }).catch(function (err) {
        _this3.showMessage("对不起，请填写注册的邮箱！");
      });
    },
    goHome: function goHome() {
      this.$router.push({ path: "/blog" });
    },
    verificate: function verificate(data) {
      for (var key in data) {
        var element = data[key];
        if (!element) {
          return false;
        }
      }
      return true;
    },
    showMessage: function showMessage(msg) {
      this.$emit("showMessage", msg);
    }
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_time_timeList_timeList__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_time_timeList_timeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_time_timeList_timeList__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      yearList: {}
    };
  },

  props: {
    articleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 10
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    nowCategorie: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    nowTagName: {
      type: String,
      default: ""
    }
  },
  components: {
    "v-sidebar": __WEBPACK_IMPORTED_MODULE_1__components_common_sidebar_sidebar___default.a,
    "v-timeList": __WEBPACK_IMPORTED_MODULE_2__components_time_timeList_timeList___default.a
  },
  watch: {
    articleList: function articleList(newVal) {
      this.filterYear();
    }
  },
  created: function created() {},

  methods: {
    getColumnArticle: function getColumnArticle(col) {
      this.$emit("getColumnArticle", col);
    },
    toTag: function toTag(itemTag) {
      this.$emit("getTagArticle", itemTag);
    },
    filterYear: function filterYear() {
      var yearList = {};
      this.articleList.forEach(function (item) {
        var year = item.date.substring(0, 4);
        if (yearList["year" + year] === undefined) {
          yearList["year" + year] = [];
        }
        yearList["year" + year].push(item);
      }, this);

      var newkey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(yearList).sort().reverse();
      var newObj = {};
      for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = yearList[newkey[i]];
      }
      this.yearList = newObj;
    }
  },
  mounted: function mounted() {
    this.filterYear();
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mavon_editor__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mavon_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mavon_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_photo_preview__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_photo_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_photo_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bmob__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_style_reset_css__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_style_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_style_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_style_markdown_less__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_style_markdown_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_style_markdown_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_font_icon_iconfont_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_font_icon_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_font_icon_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mavon_editor_dist_css_index_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mavon_editor_dist_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mavon_editor_dist_css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_photo_preview_dist_skin_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_photo_preview_dist_skin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_photo_preview_dist_skin_css__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_mavon_editor___default.a);
var option = {
  bgOpacity: 0.7,
  maxSpreadZoom: 3
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_photo_preview___default.a, option);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__bmob__["a" /* currentUser */])().then(function (result) {
      next();
      return;
    }, function (res) {
      if (res.code === '001') {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      }
    });
  } else {
    next();
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




function setCookie(key, value, iDay) {
  var oDate = new Date();
  oDate.setDate(oDate.getDate() + iDay);
  if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
  }
  value = encodeURIComponent(value);
  document.cookie = key + '=' + value + ';expires=' + oDate + ';path=/';
}

function removeCookie(key) {
  setCookie(key, '', -1);
}

function getCookie(key) {
  var cookieArr = document.cookie.split('; ');
  for (var i = 0; i < cookieArr.length; i++) {
    var arr = cookieArr[i].split('=');
    if (arr[0] === key) {
      try {
        if (decodeURIComponent(arr[1]).indexOf('}') > -1) {
          return JSON.parse(decodeURIComponent(arr[1]));
        }
        return decodeURIComponent(arr[1]);
      } catch (err) {
        return err;
      }
    }
  }
  return false;
}

function clearCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  setCookie: setCookie,
  removeCookie: removeCookie,
  getCookie: getCookie,
  clearCookie: clearCookie
});

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  "data-v-0a087fc2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  "data-v-03ac230a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  "data-v-39feadac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-645630c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  "data-v-57e6418a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  "data-v-667efea8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  "data-v-793400db",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  "data-v-2ba776ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  "data-v-372b6c68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-72acb155",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  "data-v-49ee0feb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-3fcb5239",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  "data-v-1ce988d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-20869820",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-270c8aec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-6324b600",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentComponent"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v("作者")]), _vm._v(_vm._s(_vm.userInfo.showName))]), _vm._v(" "), _c('div', {
    staticClass: "reviseTime"
  }, [_c('span', [_vm._v(" 最后修改：" + _vm._s(_vm.articleContentCopy.date) + " ")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "reviseTime"
  }, [_vm._v("\n          浏览次数：" + _vm._s(_vm.articleContentCopy.view) + "\n        ")])])]), _vm._v(" "), (_vm.editShow) ? _c('div', {
    staticClass: "editInfo"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.toEditArticle()
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("编辑")])]), _vm._v(" "), _c('div', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.toDeleteArticle()
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("删除")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.articleContentCopy.mainTitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_c('ul', _vm._l((_vm.tags), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "highlight",
      rawName: "v-highlight"
    }],
    staticClass: "markdown-content",
    attrs: {
      "id": "article"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.articleContentCopy.render)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "error-wrapper"
  }, [_c('v-Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  })], 1), _vm._v(" "), _c('v-comment', {
    staticClass: "comment"
  }), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "alertInfo": _vm.alertInfo
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BAMSide",
    attrs: {
      "id": "BAMRippleWrap"
    }
  }, [_c('div', {
    staticClass: "BAMheader"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar ? _vm.userInfo.avatar : _vm.defaultAvatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.userInfo.showName))]), _vm._v(" "), _c('p', {
    staticClass: "introduce",
    domProps: {
      "innerHTML": _vm._s(_vm.userInfo.singName)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "navList"
  }, [_c('li', {
    staticClass: "ripple",
    on: {
      "click": _vm.toSelfPage
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("我的主页")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    on: {
      "click": _vm.toSelfCodePage
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("代码片段")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BAllBlog'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BAllBlog')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("我的文章")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BWriteBlog'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BWriteBlog')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("发布文章")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BDraft'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BDraft')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("草稿箱")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BSelf'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BSelf')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("个人资料")])])])])
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "MsgSlide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow),
      expression: "messageShow"
    }],
    staticClass: "MessageCom"
  }, [_c('div', {
    staticClass: "MessageIcon"
  }, [_vm._v("i")]), _vm._v(" "), _c('p', {
    staticClass: "MessageInfo"
  }, [_vm._v(_vm._s(_vm.sendMessage))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v("前端")]), _vm._v("\n        " + _vm._s(_vm.userInfo.showName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "articleNum"
  }, [_vm._v("\n        文章：" + _vm._s(_vm.articleCount) + "\n        "), _c('span', [_vm._v(" | ")]), _vm._v("\n        字数：" + _vm._s(_vm.wordCount) + "\n      ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "articleNum"
  }, [_vm._v("\n          访问人数："), _c('span', {
    staticStyle: {
      "color": "#969696"
    }
  }, [_vm._v(_vm._s(_vm.userIpCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "singName",
    domProps: {
      "innerHTML": _vm._s(_vm.userInfo.singName)
    }
  })])]), _vm._v(" "), _c('v-article', {
    attrs: {
      "articleList": _vm.articleList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getArticleList": _vm.getArticleList,
      "showMessage": _vm.showMessage,
      "toTag": _vm.toTag
    }
  }), _vm._v(" "), _c('v-sidebar', {
    attrs: {
      "categories": _vm.categories,
      "tags": _vm.tags,
      "nowCategorie": _vm.nowCategorie,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getColumnArticle": _vm.getColumnArticle,
      "toTag": _vm.toTag
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "codeContainer"
  }, [_c('div', {
    staticClass: "lebels"
  }, [(_vm.isSelfCodePage) ? _c('button', {
    staticClass: "newSnippet",
    attrs: {
      "disabled": _vm.newDisabled
    },
    on: {
      "click": _vm.newSnippet
    }
  }, [_vm._v("\n      新建\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "allWrap",
    class: {
      active: _vm.chooseLabelIndex === 'all'
    }
  }, [_c('div', {
    staticClass: "all",
    on: {
      "click": function($event) {
        return _vm.chooseLabel('all')
      }
    }
  }, [_c('div', [_vm._v("全部代码段")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.snippetTitleListAll.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "labelsWrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("LABELS")]), _vm._v(" "), _c('ul', _vm._l((_vm.labelListAll), function(value, key) {
    return _c('li', {
      key: key,
      class: {
        active: _vm.chooseLabelIndex === key
      },
      on: {
        "click": function($event) {
          return _vm.chooseLabel(key)
        }
      }
    }, [_c('span', {
      staticClass: "info green"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(value))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, _vm._l((_vm.snippetTitleList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "snippetItem",
      class: {
        active: index === _vm.chooseItemIndex
      },
      on: {
        "click": function($event) {
          return _vm.chooseItem(index)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item.codeTitle))]), _vm._v(" "), _c('span', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cont"
    }, [_c('div', {
      staticClass: "label green"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.createdAt.slice(5, 10)))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('v-codeTitle', {
    attrs: {
      "isSelfCodePage": _vm.isSelfCodePage,
      "snippetTitle": _vm.snippetTitle,
      "snippetLabel": _vm.snippetLabel,
      "labelList": _vm.labelList,
      "newFlag": _vm.newFlag,
      "codeUrl": _vm.codeUrl
    },
    on: {
      "titleDone": _vm.titleDone,
      "hasEdit": _vm.hasEdit,
      "showMessage": _vm.showMessage,
      "delAllSnippet": _vm.delAllSnippet
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editWrap",
    class: {
      hasEdit: _vm.codeHasEdit || _vm.showCancel
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelfCodePage),
      expression: "isSelfCodePage"
    }],
    staticClass: "fileNum addFile",
    on: {
      "click": _vm.addSnippet
    }
  }, [_vm._v("\n        增加片段\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "fileNum"
  }, [_vm._v("片段 (" + _vm._s(_vm.getBmobCodeList.length) + ")")]), _vm._v(" "), _vm._l((_vm.getBmobCodeList), function(item, index) {
    return _c('div', {
      key: (index + "_" + (JSON.stringify(item).slice(10, 30))),
      staticClass: "codemirrorWrap"
    }, [_c('v-codemirror', {
      attrs: {
        "isSelfCodePage": _vm.isSelfCodePage,
        "index": index,
        "getBmobCode": item.code,
        "fileName": item.title,
        "newFlag": _vm.newFlag,
        "add": item.add
      },
      on: {
        "emitCode": _vm.getEmitCode,
        "hasEdit": _vm.hasEdit,
        "showMessage": _vm.showMessage,
        "delFile": _vm.delFile
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeHasEdit),
      expression: "codeHasEdit"
    }],
    staticClass: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.submitCode
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "icon iconfont icon-loading"
  })])])
},staticRenderFns: []}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginCom"
  }, [_c('div', {
    staticClass: "loginWrap"
  }, [_c('div', {
    staticClass: "avatar iconfont icon-touxiang"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    class: {
      active: _vm.tabFlag === 'login'
    },
    on: {
      "click": function($event) {
        _vm.tabFlag = 'login'
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.tabFlag === 'register'
    },
    on: {
      "click": function($event) {
        _vm.tabFlag = 'register'
      }
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('form', {
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loginSubmit($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag !== 'resetPassword'),
      expression: "tabFlag !== 'resetPassword'"
    }],
    staticClass: "userName"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邮箱"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag !== 'resetPassword'),
      expression: "tabFlag !== 'resetPassword'"
    }],
    staticClass: "userPsw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPwd),
      expression: "userPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.userPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'register'),
      expression: "tabFlag === 'register'"
    }],
    staticClass: "userPsw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPwdAngin),
      expression: "userPwdAngin"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次确认密码"
    },
    domProps: {
      "value": (_vm.userPwdAngin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPwdAngin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'resetPassword'),
      expression: "tabFlag === 'resetPassword'"
    }],
    staticClass: "userName"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restPwdEmail),
      expression: "restPwdEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邮箱"
    },
    domProps: {
      "value": (_vm.restPwdEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.restPwdEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'login'),
      expression: "tabFlag === 'login'"
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loginSubmit($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.loginStatu) + "\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'register'),
      expression: "tabFlag === 'register'"
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loginSubmit($event)
      }
    }
  }, [_vm._v("\n          注册\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'resetPassword'),
      expression: "tabFlag === 'resetPassword'"
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_vm._v("\n          重置密码\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabFlag === 'login'),
      expression: "tabFlag === 'login'"
    }],
    staticClass: "resetPassword",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.tabFlag = 'resetPassword'
      }
    }
  }, [_vm._v("\n        忘记密码?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "resetPassword",
    staticStyle: {
      "float": "left",
      "text-align": "left"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goHome($event)
      }
    }
  }, [_vm._v("\n        返回首页\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BAllBlog"
  }, [_c('div', {
    staticClass: "allBlogContent"
  }, [_c('v-article', {
    attrs: {
      "articleList": _vm.articleList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPageCopy,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading,
      "toEdit": true,
      "isArticle": true
    },
    on: {
      "getCategories": _vm.getCategories,
      "showMessage": _vm.showMessage
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BDraft"
  }, [_c('div', {
    staticClass: "allBlogContent"
  }, [_c('v-article', {
    attrs: {
      "articleList": _vm.articleList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading,
      "toEdit": true,
      "isDraft": true
    },
    on: {
      "showMessage": _vm.showMessage
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "codemirrorWrapper",
    class: {
      editing: _vm.editing
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('input', {
    staticClass: "name",
    class: {
      sbTitle: !_vm.editing
    },
    attrs: {
      "placeholder": "文件名(带后缀名，高亮检查)",
      "disabled": !_vm.editing
    },
    domProps: {
      "value": _vm.title
    },
    on: {
      "input": _vm.titleChange
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelfCodePage),
      expression: "isSelfCodePage"
    }],
    staticClass: "edit"
  }, [_c('span', {
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.editOrDone))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.alertShow = true
      }
    }
  }, [_vm._v("删除")])])]), _vm._v(" "), _c('v-codemirror', {
    attrs: {
      "options": _vm.cmOptions,
      "value": _vm.code
    },
    on: {
      "input": _vm.onCmCodeChange
    }
  }), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "info": "确认删除此片段？"
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": function($event) {
        _vm.alertShow = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articleComponent"
  }, [_c('v-content', {
    attrs: {
      "articleContent": _vm.articleContent,
      "tags": _vm.tags,
      "userInfo": _vm.userInfo,
      "isLoading": _vm.isLoading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('v-header', {
    on: {
      "searchInfo": _vm.searchInfo,
      "getWordCount": _vm.getWordCount
    }
  }), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "blog",
    attrs: {
      "articleList": _vm.articleListCopy,
      "articleCount": _vm.articleCount,
      "wordCount": _vm.wordCount,
      "userIpCount": _vm.userIpCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "userInfo": _vm.userInfo,
      "isLoading": _vm.isLoading,
      "categories": _vm.categories,
      "nowCategorie": _vm.nowCategorie,
      "tags": _vm.tags,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getCategories": _vm.getCategories,
      "getTagArticle": _vm.getTagArticle,
      "getColumnArticle": _vm.getColumnArticle,
      "getArticleList": _vm.getArticleList,
      "getWordCount": _vm.getWordCount,
      "geUserIpCount": _vm.geUserIpCount,
      "showMessage": _vm.showMessage,
      "clearArticleList": _vm.clearArticleList
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "blog",
    attrs: {
      "articleList": _vm.articleListCopy,
      "articleCount": _vm.articleCount,
      "wordCount": _vm.wordCount,
      "userIpCount": _vm.userIpCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "userInfo": _vm.userInfo,
      "isLoading": _vm.isLoading,
      "categories": _vm.categories,
      "nowCategorie": _vm.nowCategorie,
      "tags": _vm.tags,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getCategories": _vm.getCategories,
      "getTagArticle": _vm.getTagArticle,
      "getColumnArticle": _vm.getColumnArticle,
      "getArticleList": _vm.getArticleList,
      "getWordCount": _vm.getWordCount,
      "geUserIpCount": _vm.geUserIpCount,
      "showMessage": _vm.showMessage,
      "clearArticleList": _vm.clearArticleList
    }
  }) : _vm._e(), _vm._v(" "), _c('v-Message', {
    attrs: {
      "messageShow": _vm.messageShow,
      "sendMessage": _vm.sendMessage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "WriteBlog"
  }, [_c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOriginal),
      expression: "isOriginal"
    }],
    staticClass: "original",
    attrs: {
      "name": "original"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isOriginal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "原创"
    }
  }, [_vm._v("原创")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "转载"
    }
  }, [_vm._v("转载")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleTitle),
      expression: "articleTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "我的新博客..."
    },
    domProps: {
      "value": (_vm.articleTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.articleTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('mavon-editor', {
    ref: "mavon",
    staticClass: "mavonEditor",
    attrs: {
      "toolbars": _vm.toolbars,
      "subfield": _vm.subfield,
      "toolbarsFlag": _vm.toolbarsFlag,
      "ishljs": _vm.ishljs,
      "codeStyle": _vm.codeStyle,
      "placeholder": _vm.placeholder
    },
    on: {
      "save": _vm.save,
      "change": _vm.change,
      "imgAdd": _vm.imgAdd,
      "imgDel": _vm.imgDel
    },
    model: {
      value: (_vm.articleValue),
      callback: function($$v) {
        _vm.articleValue = $$v
      },
      expression: "articleValue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button recordInfo"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.saveRecord ? "最后一次暂存时间：" + _vm.lastTime : "未暂存"))]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveRecord),
      expression: "saveRecord"
    }],
    on: {
      "click": function($event) {
        return _vm.clearLocal()
      }
    }
  }, [_vm._v("清除暂存")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.col), function(value, key) {
    return _c('li', {
      key: key,
      class: {
        active: _vm.chooseColumn === key
      },
      on: {
        "click": function($event) {
          return _vm.chooseCol(key, value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(key) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addColumnShow),
      expression: "addColumnShow"
    }],
    staticClass: "addColumn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addColumnInfo),
      expression: "addColumnInfo"
    }],
    ref: "addColumn",
    attrs: {
      "type": "text",
      "placeholder": "添加分类..."
    },
    domProps: {
      "value": (_vm.addColumnInfo)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addColumnSure($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addColumnInfo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addColumnSure
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('button', {
    staticClass: "more",
    on: {
      "click": _vm.addColumn
    }
  }, [_vm._v("添加更多")])]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "addTagsInfo"
  }, _vm._l((_vm.tags), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item) + "\n          "), _c('i', {
      attrs: {
        "index": index
      },
      on: {
        "click": _vm.deleteTag
      }
    }, [_vm._v("×")])]), _vm._v(" "), _c('span', {
      staticClass: "bugle"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enterTagsInfo),
      expression: "enterTagsInfo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入标签，最多三个，Enter提交"
    },
    domProps: {
      "value": (_vm.enterTagsInfo)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTagsSure($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enterTagsInfo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [(this.allowPush) ? _c('button', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.addArticle(true)
      }
    }
  }, [_vm._v("\n      发布\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.addArticle(false)
      }
    }
  }, [_vm._v("保存草稿")])]), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "info": _vm.alertInfo
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    }
  }), _vm._v(" "), (_vm.loadingShow) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "icon iconfont icon-loading"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "chinese"
  }, [_vm._v("分类")]), _vm._v(" "), _c('span', {
    staticClass: "english"
  }, [_vm._v("GATEGORIES:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "chinese"
  }, [_vm._v("标签")]), _vm._v(" "), _c('span', {
    staticClass: "english"
  }, [_vm._v("TAGS:")])])
}]}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "gitalk-container"
    }
  })])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tagsCom"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("tag cloud")]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index <= 15 || _vm.isMore),
        expression: "index <= 15 || isMore"
      }],
      key: index,
      class: {
        active: _vm.nowTagName === item
      },
      on: {
        "click": function($event) {
          return _vm.chooseTag(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(item))])])
  }), 0), _vm._v(" "), (_vm.tags.length > 15 && !_vm.isMore) ? _c('div', {
    staticClass: "more",
    on: {
      "click": _vm.getMore
    }
  }, [_c('span', [_vm._v("查看更多")]), _vm._v(" "), _c('i', [_vm._v(">")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errorWrap"
  }, [_c('div', {
    staticClass: "iconfont icon-wushuju icon"
  }, [_c('span', [_vm._v("暂无数据")])])])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadingWrap"
  }, [_c('div', {
    staticClass: "icon iconfont icon-loading"
  }, [_c('span', [_vm._v("Loading...")])])])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "catalogue",
    attrs: {
      "id": "sideBarRippleWrap"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("gategories")]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('ul', {
    staticClass: "fadeOutList"
  }, [_c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.nowCategorie === ''
    },
    on: {
      "click": function($event) {
        return _vm.getArticle()
      }
    }
  }, [_c('p'), _vm._v(" "), _c('i', [_vm._v(">")]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("全部")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.allLength))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.categories), function(item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index <= 10 || _vm.isMore),
        expression: "index <= 10 || isMore"
      }],
      key: index,
      staticClass: "ripple",
      class: {
        active: _vm.nowCategorie === item.col
      },
      on: {
        "click": function($event) {
          return _vm.getArticle(item.col)
        }
      }
    }, [_c('p'), _vm._v(" "), _c('i', [_vm._v(">")]), _vm._v(" "), _c('span', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item.col))]), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item._count))]), _vm._v(" "), _vm._m(1, true)])
  })], 2), _vm._v(" "), (_vm.categories.length > 10 && !_vm.isMore) ? _c('div', {
    staticClass: "more",
    on: {
      "click": _vm.getMore
    }
  }, [_c('span', [_vm._v("查看更多")]), _vm._v(" "), _c('i', [_vm._v(">")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
}]}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert"
  }, [_c('div', {
    staticClass: "alertWrapper"
  }, [_c('div', {
    staticClass: "alertInfo"
  }, [_vm._v(_vm._s(_vm.info))]), _vm._v(" "), _c('div', {
    staticClass: "btnWrap"
  }, [_c('span', {
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])])
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time"
  }, [_c('v-timeList', {
    attrs: {
      "yearList": _vm.yearList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('v-sidebar', {
    attrs: {
      "categories": _vm.categories,
      "tags": _vm.tags,
      "nowCategorie": _vm.nowCategorie,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getColumnArticle": _vm.getColumnArticle,
      "toTag": _vm.toTag
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "titleWrap"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snippetTitleCopy),
      expression: "snippetTitleCopy"
    }],
    class: {
      edit: _vm.editing
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入标题",
      "disabled": !_vm.editing
    },
    domProps: {
      "value": (_vm.snippetTitleCopy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.snippetTitleCopy = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing && _vm.chooseLabelItem),
      expression: "!editing && chooseLabelItem"
    }],
    staticClass: "label green"
  }, [_vm._v(_vm._s(_vm.chooseLabelItem))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelfCodePage),
      expression: "isSelfCodePage"
    }]
  }, [_c('span', {
    staticClass: "last",
    on: {
      "click": function($event) {
        _vm.alertShow = true
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('span', {
    staticClass: "last",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.editOrDone))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    staticClass: "labelWrap"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v("请选择标签：")]), _vm._v(" "), _c('ul', _vm._l((_vm.labelListCopy), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "label green",
      class: {
        active: _vm.chooseLabelIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.chooseLabel(index, item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addLabelShow),
      expression: "addLabelShow"
    }],
    staticClass: "addColumn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addLabelInfo),
      expression: "addLabelInfo"
    }],
    ref: "addLabel",
    attrs: {
      "type": "text",
      "placeholder": "添加分类..."
    },
    domProps: {
      "value": (_vm.addLabelInfo)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addLabelSure($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addLabelInfo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addLabelSure
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('button', {
    staticClass: "more",
    on: {
      "click": _vm.addLabel
    }
  }, [_vm._v("添加")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "url"
  }, [_c('span', [_vm._v("访问地址：")]), _vm._v(" "), _c('span', {
    staticClass: "codeUrl"
  }, [_c('p', [_vm._v(_vm._s(_vm.codeUrl))])])]), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "info": "确认删除整个代码块？"
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": function($event) {
        _vm.alertShow = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeList"
  }, [_vm._l((_vm.yearList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('h2', [_vm._v(_vm._s(index.substring(4)))]), _vm._v(" "), _c('ul', _vm._l((item), function(article, idx) {
      return _c('li', {
        key: idx
      }, [_c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(article.date.substring(5, 10)))]), _vm._v(" "), _c('div', {
        staticClass: "title",
        domProps: {
          "innerHTML": _vm._s(article.mainTitle)
        },
        on: {
          "click": function($event) {
            return _vm.toArticlePage(article.ID)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "tags"
      }, _vm._l((article.tags), function(tag, i) {
        return _c('span', {
          key: i,
          staticClass: "item"
        }, [_vm._v(_vm._s(tag))])
      }), 0)])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "error-wrapper"
  }, [_c('v-Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), (!_vm.isLoading && !Object.keys(_vm.yearList).length) ? _c('v-ErrorCom') : _vm._e()], 1), _vm._v(" "), (
    _vm.currentPage !== _vm.allPageNum && !_vm.isLoading && Object.keys(_vm.yearList).length
  ) ? _c('li', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0",
      "color": "'#666666'"
    }
  }, [_vm._v("\n    上拉滑动查看更多\n  ")]) : _vm._e(), _vm._v(" "), (
    _vm.currentPage == _vm.allPageNum && !_vm.isLoading && Object.keys(_vm.yearList).length
  ) ? _c('li', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0",
      "color": "'#666666'"
    }
  }, [_vm._v("\n    我是有底线的 (¯^¯ )\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header",
    class: {
      BAM: _vm.isBAM
    },
    attrs: {
      "id": "headerRippleWrap"
    }
  }, [_c('h1', {
    staticClass: "iconfont icon-fepawn",
    on: {
      "click": function($event) {
        return _vm.changeHash('blog')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "headerR"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchIsShow),
      expression: "searchIsShow"
    }],
    staticClass: "search",
    class: {
      active: _vm.slideDown
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo",
    on: {
      "click": _vm.showSearch
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInfo),
      expression: "searchInfo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入搜索内容回车"
    },
    domProps: {
      "value": (_vm.searchInfo)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.searchSubmit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInfo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.userID) ? _c('div', {
    staticClass: "logout ripple",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "iconfont icon-git46"
  }), _vm._v(" "), _c('span', {
    staticClass: "Tooltip"
  }, [_vm._v("退出")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "person",
    class: {
      activeType: _vm.activeRoute.indexOf('/BAM') > -1
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('BAM')
      }
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "Tooltip"
  }, [_vm._v("个人中心")])])]), _vm._v(" "), _c('nav', {
    staticClass: "nav"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navListIsShow),
      expression: "navListIsShow"
    }]
  }, [_c('li', {
    staticClass: "ripple",
    class: {
      activeType: _vm.activeRoute === '/blog' || _vm.activeRoute === '/article'
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('blog')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-home1149866easyiconnet"
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("博客")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      activeType: _vm.activeRoute === '/time'
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('time')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-emizhifeiji"
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("归档")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      activeType: _vm.activeRoute === '/code'
    },
    on: {
      "click": function($event) {
        return _vm.changeHash('code')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-insert_tag_field"
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("代码段")]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('v-Message', {
    attrs: {
      "messageShow": _vm.messageShow,
      "sendMessage": _vm.sendMessage
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rippleWrap"
  }, [_c('span')])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Bself"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('div', {
    staticClass: "imgContent"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "alt": "头像"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "avatar",
      "id": "avatar",
      "value": "上传头像",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadAvatar
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "avatar"
    }
  }, [_vm._v("上传头像")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("昵称：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showName),
      expression: "showName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.showName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.showName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "shortInt"
  }, [_c('p', [_vm._v("个人简介：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortInt),
      expression: "shortInt"
    }],
    attrs: {
      "name": "shortInt",
      "cols": "50",
      "rows": "6",
      "maxlength": "500",
      "placeholder": "请输入您的个人简介"
    },
    domProps: {
      "value": (_vm.shortInt)
    },
    on: {
      "change": _vm.updateShortInt,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shortInt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fontNum"
  }, [_vm._v("剩余可输入" + _vm._s(_vm.surplus) + "/500字")])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('button', {
    on: {
      "click": _vm.updateSelfInfo
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BAMCom",
    attrs: {
      "id": "BAMCom"
    }
  }, [_c('v-BAMSide', {
    attrs: {
      "userInfo": _vm.userInfo
    }
  }), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "articleList": _vm.articleList,
      "userInfo": _vm.userInfo,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading
    },
    on: {
      "getArticleList": _vm.getArticleList,
      "getCategories": _vm.getCategories,
      "getWordCount": _vm.getWordCount,
      "clearArticleList": _vm.clearArticleList,
      "showMessage": _vm.showMessage
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "articleList": _vm.articleList,
      "userInfo": _vm.userInfo,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading
    },
    on: {
      "getArticleList": _vm.getArticleList,
      "getCategories": _vm.getCategories,
      "getWordCount": _vm.getWordCount,
      "clearArticleList": _vm.clearArticleList,
      "showMessage": _vm.showMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('v-Message', {
    attrs: {
      "messageShow": _vm.messageShow,
      "sendMessage": _vm.sendMessage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('v-catalogue', {
    attrs: {
      "categories": _vm.categories,
      "nowCategorie": _vm.nowCategorie
    },
    on: {
      "getColumnArticle": _vm.getColumnArticle
    }
  }), _vm._v(" "), _c('v-blogTags', {
    attrs: {
      "tags": _vm.tags,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "toTag": _vm.toTag
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article",
    attrs: {
      "id": "articleRippleWrap"
    }
  }, [_c('ul', [_vm._l((_vm.articleList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item"
    }, [_c('p', {
      staticClass: "mainTitle",
      on: {
        "click": function($event) {
          return _vm.toArticlePage(item.ID)
        }
      }
    }, [_c('span', [_vm._v("[" + _vm._s(item.original) + "]")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.mainTitle)
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, _vm._l((item.tags), function(tag, i) {
      return _c('li', {
        key: i,
        class: {
          active: _vm.nowTagName === tag
        },
        on: {
          "click": function($event) {
            return _vm.chooseTag(tag)
          }
        }
      }, [_vm._v("\n          " + _vm._s(tag) + "\n        ")])
    }), 0), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.toArticlePage(item.ID)
        }
      }
    }, [_c('div', [_c('p', {
      staticClass: "intro",
      domProps: {
        "innerHTML": _vm._s(item.intro + '...')
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "box-shadow": "inset 0px -10px 15px -10px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("更新时间：" + _vm._s(item.updateDate) + "  ")]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_vm._v("\n            |  分类：\n            "), _c('span', [_vm._v(_vm._s(item.col))])]), _vm._v(" "), _c('div', {
      staticClass: "floor"
    }, [_c('span', [_vm._v("  |  # " + _vm._s(index + 1))])])]), _vm._v(" "), (!_vm.toEdit && !_vm.isDraft) ? _c('p', {
      staticClass: "readMore"
    }, [_vm._v("查看详情...")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(_vm.toEdit && _vm.isDraft) ? _c('div', {
      staticClass: "more",
      on: {
        "click": function($event) {
          return _vm.toEditDraft(item.ID)
        }
      }
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v("编辑")])]) : _vm._e(), _vm._v(" "), (_vm.toEdit && _vm.isDraft) ? _c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.toDeleteArticle(item.ID, index, 'draft')
        }
      }
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), (_vm.toEdit && _vm.isArticle) ? _c('div', {
      staticClass: "more",
      on: {
        "click": function($event) {
          return _vm.toEditArticle(item.ID)
        }
      }
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v("编辑")])]) : _vm._e(), _vm._v(" "), (_vm.toEdit && _vm.isArticle) ? _c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.toDeleteArticle(item.ID, index, 'article')
        }
      }
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v("删除")])]) : _vm._e()])])
  }), _vm._v(" "), (_vm.currentPage == _vm.allPageNum && !_vm.isLoading && _vm.articleList.length) ? _c('li', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0",
      "color": "'#666666'"
    }
  }, [_vm._v("\n      我是有底线的 (¯^¯ )\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "error-wrapper"
  }, [_c('v-Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), _c('v-ErrorCom', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && !_vm.articleList.length),
      expression: "!isLoading && !articleList.length"
    }]
  })], 1), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "alertInfo": _vm.alertInfo
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[130]);


// WEBPACK FOOTER //
// static/js/app.9b80a8b7b044ae337d0f.js